webpackJsonp([0],{

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(1);
exports.destinations = [
//    {name: "Disneyland® Resort", code: "Disneyland Resort"},
{ name: "Walt Disney World® Resort", code: "Walt Disney World Resort" }];
function destinationLabel(dest) {
    var d = exports.destinations.find(function (d) {
        return d.code === dest;
    });
    return d ? d.name : dest;
}
exports.destinationLabel = destinationLabel;
function convertSearchResponse(response) {
    return Object.assign({}, response, { checkIn: moment(response.checkIn), checkOut: moment(response.checkOut) });
}
exports.convertSearchResponse = convertSearchResponse;
exports.defaultTicket = function () {
    return {
        name: "",
        destination: exports.destinations[0].code,
        adultPrice: 0,
        childPrice: 0,
        days: 3,
        validRange: 5,
        active: true
    };
};

/***/ }),

/***/ 1070:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(513);
module.exports = __webpack_require__(514);


/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(36);
var react_router_dom_1 = __webpack_require__(49);
var react_bootstrap_1 = __webpack_require__(26);
var lodash_1 = __webpack_require__(25);
__webpack_require__(62);
__webpack_require__(71);
__webpack_require__(98);
var hotels_1 = __webpack_require__(37);
__webpack_require__(85);
var hotels_2 = __webpack_require__(107);
var utils_1 = __webpack_require__(38);

var Cart = function (_React$Component) {
    _inherits(Cart, _React$Component);

    function Cart() {
        _classCallCheck(this, Cart);

        return _possibleConstructorReturn(this, (Cart.__proto__ || Object.getPrototypeOf(Cart)).apply(this, arguments));
    }

    _createClass(Cart, [{
        key: "render",
        value: function render() {
            return this.renderCart();
        }
    }, {
        key: "renderCart",
        value: function renderCart() {
            var _this2 = this;

            if (!this.props.order || lodash_1.isEmpty(this.props.tickets)) {
                return null;
            }
            var isReadOnly = this.isReadOnlyURL();
            var hotels = null;
            if (!lodash_1.isEmpty(this.props.order.hotel)) {
                hotels = React.createElement(react_bootstrap_1.Table, { striped: true, hover: true, className: "cart-hotels" }, React.createElement("thead", null, React.createElement("tr", null, React.createElement("th", null, "Hotel"), React.createElement("th", null, "Dates"), React.createElement("th", null, "Occupants"), React.createElement("th", null))), React.createElement("tbody", null, lodash_1.map(this.props.order.hotel, function (orderHotel, index) {
                    return React.createElement("tr", { key: index }, React.createElement("td", null, React.createElement(react_router_dom_1.Link, { to: "/hotels/" + orderHotel.hotelId }, orderHotel.hotelTitle), React.createElement("br", null), orderHotel.roomTitle), React.createElement("td", null, React.createElement("div", null, React.createElement("label", null, "Check-in"), React.createElement("div", null, orderHotel.checkIn.format(utils_1.LOCAL_DATE_FMT))), React.createElement("div", null, React.createElement("label", null, "Check-out"), React.createElement("div", null, orderHotel.checkOut.format(utils_1.LOCAL_DATE_FMT)))), React.createElement("td", null, React.createElement("div", null, React.createElement("label", null, "Adults"), React.createElement("div", null, orderHotel.numAdults)), React.createElement("div", null, React.createElement("label", null, "Children"), React.createElement("div", null, lodash_1.size(orderHotel.childAges)))), React.createElement("td", { className: "actions" }, isReadOnly || React.createElement(react_bootstrap_1.Button, { className: "hint--bottom", onClick: function onClick() {
                            return _this2.removeHotel(orderHotel);
                        }, "aria-label": "Remove Hotel" }, React.createElement("i", { className: "fa fa-remove" }))));
                })));
            }
            var tickets = React.createElement(react_bootstrap_1.ListGroup, null, React.createElement(react_bootstrap_1.ListGroupItem, null, "Your order has no tickets"));
            if (!lodash_1.isEmpty(this.props.order.tickets)) {
                tickets = React.createElement(react_bootstrap_1.Table, { striped: true, hover: true }, React.createElement("thead", null, React.createElement("tr", null, React.createElement("th", null, "Ticket"), React.createElement("th", null, "# Adults"), React.createElement("th", null, "# Children"), React.createElement("th", null, "First Day"), React.createElement("th", null))), React.createElement("tbody", null, lodash_1.map(this.props.order.tickets, function (orderTicket, index) {
                    var ticket = _this2.props.tickets[orderTicket.ticketId];
                    return React.createElement("tr", { key: index }, React.createElement("td", null, hotels_2.destinationLabel(ticket.destination), " ", ticket.days, "-Day ", ticket.name), React.createElement("td", null, orderTicket.quantityAdults), React.createElement("td", null, orderTicket.quantityChildren), React.createElement("td", null, orderTicket.firstDate), React.createElement("td", { className: "actions" }, isReadOnly || React.createElement(react_bootstrap_1.Button, { className: "hint--bottom", onClick: function onClick() {
                            return _this2.removeTicket(orderTicket);
                        }, "aria-label": "Remove Ticket" }, React.createElement("i", { className: "fa fa-remove" }))));
                })));
            }
            return React.createElement("div", null, tickets);
        }
    }, {
        key: "removeTicket",
        value: function removeTicket(ticket) {
            if (this.isReadOnlyURL()) {
                return;
            }
            var order = this.props.order;
            var index = lodash_1.indexOf(order.tickets, ticket);
            if (index > -1) {
                order.tickets.splice(index, 1);
            }
            order.ticketsSelected = true;
            this.props.updateOrder(order);
        }
    }, {
        key: "removeHotel",
        value: function removeHotel(hotel) {
            if (this.isReadOnlyURL()) {
                return;
            }
            var order = this.props.order;
            var index = lodash_1.indexOf(order.hotel, hotel);
            if (index > -1) {
                order.hotel.splice(index, 1);
            }
            this.props.updateOrder(order);
        }
    }, {
        key: "isReadOnlyURL",
        value: function isReadOnlyURL() {
            return this.props.location.pathname.indexOf("checkout") > -1 || this.props.location.pathname.indexOf("review") > -1 || this.props.location.pathname.indexOf("summary") > -1;
        }
    }]);

    return Cart;
}(React.Component);

var connected = react_redux_1.connect(function (state) {
    return {
        order: state.hotels.order,
        search: state.hotels.searchCriteria,
        tickets: state.config.tickets,
        loading: state.hotels.loading || state.hotels.orderLoading || state.hotels.searchLoading
    };
}, {
    updateOrder: hotels_1.updateOrder
})(Cart);
exports.default = react_router_dom_1.withRouter(connected);

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(73);
var lodash_1 = __webpack_require__(25);
exports.ORDERS_LOADING = "ORDERS_LOADING";
exports.ORDERS_LOADED = "ORDERS_LOADED";
exports.ORDERS_DETAIL_LOADED = "ORDERS_DETAIL_LOADED";
exports.ORDERS_DETAIL_UPDATE = "ORDERS_DETAIL_UPDATE";
exports.ORDERS_UPDATE_SEARCH_PARAMS = "ORDERS_UPDATE_SEARCH_PARAMS";
exports.ORDERS_API_ERROR = "ORDERS_API_ERROR";
exports.ORDERS_DECRYPTED_TRANS = "ORDERS_DECRYPTED_TRANS";
exports.ORDERS_SET_KEY = "ORDERS_SET_KEY";
exports.ORDERS_EMAIL_SENT = "ORDERS_EMAIL_SENT";
function getOrderList(params) {
    return function (dispatch) {
        dispatch({ type: exports.ORDERS_LOADING });
        var urlParams = lodash_1.compact([params.search ? "search=" + encodeURIComponent(params.search) : null, params.maxDate ? "maxDate=" + encodeURIComponent(params.maxDate) : null, params.minDate ? "minDate=" + encodeURIComponent(params.minDate) : null]).join("&");
        return common_1.apiRequest("/orders?" + urlParams).then(function (response) {
            return dispatch({
                type: exports.ORDERS_LOADED,
                orderList: response
            });
        }).catch(function (err) {
            return dispatch(common_1.apiError(exports.ORDERS_API_ERROR, err));
        });
    };
}
exports.getOrderList = getOrderList;
function getOrderDetail(id) {
    return function (dispatch) {
        dispatch({ type: exports.ORDERS_LOADING });
        return common_1.apiRequest("/orders/" + id).then(function (response) {
            return dispatch({
                type: exports.ORDERS_DETAIL_LOADED,
                orderDetail: response
            });
        }).catch(function (err) {
            return dispatch(common_1.apiError(exports.ORDERS_API_ERROR, err));
        });
    };
}
exports.getOrderDetail = getOrderDetail;
function resendOrderConfirmationEmail(id) {
    return function (dispatch) {
        dispatch({ type: exports.ORDERS_LOADING });
        return common_1.apiPut("/orders/" + id + "/send_confirmation_email", {}).then(function () {
            return dispatch({
                type: exports.ORDERS_EMAIL_SENT
            });
        }).catch(function (err) {
            return dispatch(common_1.apiError(exports.ORDERS_API_ERROR, err));
        });
    };
}
exports.resendOrderConfirmationEmail = resendOrderConfirmationEmail;
function getDecryptedTransactions(id, key) {
    return function (dispatch) {
        dispatch({ type: exports.ORDERS_LOADING });
        return common_1.apiPut("/orders/" + id + "/transactions/decrypt", key, "text/plain").then(function (response) {
            return dispatch({
                type: exports.ORDERS_DECRYPTED_TRANS,
                transactions: response
            });
        }).catch(function (err) {
            dispatch(common_1.apiError(exports.ORDERS_API_ERROR, err));
            dispatch(setKey(""));
        });
    };
}
exports.getDecryptedTransactions = getDecryptedTransactions;
function setKey(key) {
    return { type: exports.ORDERS_SET_KEY, key: key };
}
exports.setKey = setKey;
function updateSearchParams(params) {
    return {
        type: exports.ORDERS_UPDATE_SEARCH_PARAMS,
        orderSearchParams: params
    };
}
exports.updateSearchParams = updateSearchParams;
function setErrorMessage(msg) {
    return {
        type: exports.ORDERS_API_ERROR,
        errorMessage: msg
    };
}
exports.setErrorMessage = setErrorMessage;
function updateOrderDetailStore(order) {
    return {
        type: exports.ORDERS_DETAIL_UPDATE,
        orderDetail: lodash_1.clone(order)
    };
}
exports.updateOrderDetailStore = updateOrderDetailStore;
function updateOrder(order) {
    return function (dispatch) {
        dispatch({ type: exports.ORDERS_LOADING });
        return common_1.apiPut("/orders/" + order.orderId, order).then(function (response) {
            return dispatch({
                type: exports.ORDERS_DETAIL_LOADED,
                orderDetail: response
            });
        }).catch(function (err) {
            return dispatch(common_1.apiError(exports.ORDERS_API_ERROR, err));
        });
    };
}
exports.updateOrder = updateOrder;

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(73);
var token_1 = __webpack_require__(169);
exports.LOGGING_IN = "LOGGING_IN";
exports.LOGIN_COMPLETE = "LOGIN_COMPLETE";
exports.LOAD_LOGGED_IN_FAILED = "LOAD_LOGGED_IN_FAILED";
exports.SECURITY_API_ERROR = "SECURITY_API_ERROR";
function login(username, password) {
    return function (dispatch) {
        dispatch({ type: exports.LOGGING_IN });
        return common_1.apiPost("/auth/signIn", { username: username, password: password }).then(function (response) {
            token_1.setToken(response.token);
            return dispatch({
                type: exports.LOGIN_COMPLETE,
                user: response
            });
        }).catch(function (err) {
            return dispatch(common_1.apiError(exports.SECURITY_API_ERROR, "Login Failed"));
        });
    };
}
exports.login = login;
function loadLoggedInUser() {
    return function (dispatch) {
        dispatch({ type: exports.LOGGING_IN });
        return common_1.apiRequest("/users/me").then(function (response) {
            return dispatch({
                type: exports.LOGIN_COMPLETE,
                user: response
            });
        }).catch(function (err) {
            dispatch({
                type: exports.LOAD_LOGGED_IN_FAILED
            });
            dispatch(common_1.apiError(exports.SECURITY_API_ERROR, err));
        });
    };
}
exports.loadLoggedInUser = loadLoggedInUser;
function logout() {
    return function (dispatch) {
        dispatch({ type: exports.LOGGING_IN });
        return common_1.apiRequest("/auth/signOut").then(function (response) {
            token_1.deleteToken();
            return dispatch({
                type: exports.LOGIN_COMPLETE,
                user: null
            });
        }).catch(function (err) {
            return dispatch(common_1.apiError(exports.SECURITY_API_ERROR, err));
        });
    };
}
exports.logout = logout;

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(1);
var api_1 = __webpack_require__(249);
var utils_1 = __webpack_require__(38);
var sessionToken = null;
var sessionTokenPromise = null;
var LS_TOKEN = "_session_token";
function tokenValidated(isValid) {
    if (sessionToken) {
        sessionToken.validated = isValid;
        utils_1.localStorageSet(LS_TOKEN, JSON.stringify(sessionToken));
    }
}
exports.tokenValidated = tokenValidated;
function setToken(token) {
    sessionToken = token;
    tokenValidated(!!token.userId);
}
exports.setToken = setToken;
function deleteToken() {
    sessionToken = null;
    utils_1.localStorageRemove(LS_TOKEN);
}
exports.deleteToken = deleteToken;
function getToken() {
    return sessionToken;
}
exports.getToken = getToken;
function requestNewToken(storedToken) {
    var options = { headers: {} };
    if (storedToken) {
        options.headers.Token = storedToken.token;
    }
    return fetch(api_1.apiBase() + "/auth/token", options).then(function (results) {
        return results.json();
    });
}
exports.requestNewToken = requestNewToken;
function ensureToken() {
    var storedToken = null;
    if (!sessionToken && utils_1.localStorageGet(LS_TOKEN)) {
        try {
            storedToken = JSON.parse(utils_1.localStorageGet(LS_TOKEN));
            if (storedToken && moment(storedToken.expiresOn).isAfter(moment())) {
                sessionToken = storedToken;
                return Promise.resolve(storedToken);
            }
        } catch (e) {
            storedToken = null;
        }
    }
    if (sessionToken && moment(sessionToken.expiresOn).isAfter(moment())) {
        return Promise.resolve(sessionToken);
    }
    if (sessionTokenPromise) {
        return sessionTokenPromise;
    }
    sessionTokenPromise = requestNewToken(storedToken).then(function (token) {
        sessionToken = token;
        sessionTokenPromise = null;
        utils_1.localStorageSet(LS_TOKEN, JSON.stringify(sessionToken));
        return token;
    });
    return sessionTokenPromise;
}
exports.ensureToken = ensureToken;

/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(38);
var react_bootstrap_1 = __webpack_require__(26);
exports.PackageTotals = function (props) {
    var _props$order = props.order,
        grandTotal = _props$order.grandTotal,
        subTotal = _props$order.subTotal,
        discountTotal = _props$order.discountTotal,
        taxTotal = _props$order.taxTotal,
        shippingTotal = _props$order.shippingTotal,
        insuranceTotal = _props$order.insuranceTotal,
        memoryMakerTotal = _props$order.memoryMakerTotal,
        geniePlusTotal = _props$order.geniePlusTotal;

    return React.createElement("div", null, React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { md: 2, className: "total-label" }, "Subtotal"), React.createElement(react_bootstrap_1.Col, { md: 2, className: "subtotal" }, utils_1.moneyFormat(subTotal))), discountTotal > 0 && React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { md: 2, className: "total-label" }, "Discount"), React.createElement(react_bootstrap_1.Col, { md: 2, className: "subtotal" }, utils_1.moneyFormat(discountTotal))), taxTotal > 0 && React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { md: 2, className: "total-label" }, "Tax"), React.createElement(react_bootstrap_1.Col, { md: 2, className: "subtotal" }, utils_1.moneyFormat(taxTotal))), shippingTotal > 0 && React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { md: 2, className: "total-label" }, "Delivery"), React.createElement(react_bootstrap_1.Col, { md: 2, className: "subtotal" }, utils_1.moneyFormat(shippingTotal))), insuranceTotal > 0 && React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { md: 2, className: "total-label" }, "Insurance"), React.createElement(react_bootstrap_1.Col, { md: 2, className: "subtotal" }, utils_1.moneyFormat(insuranceTotal))), memoryMakerTotal > 0 && React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { md: 2, className: "total-label" }, "Memory Maker"), React.createElement(react_bootstrap_1.Col, { md: 2, className: "subtotal" }, utils_1.moneyFormat(memoryMakerTotal))), geniePlusTotal > 0 && React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { md: 2, className: "total-label" }, "Genie+"), React.createElement(react_bootstrap_1.Col, { md: 2, className: "subtotal" }, utils_1.moneyFormat(geniePlusTotal))), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { md: 2, className: "total-label bold" }, "Grand Total"), React.createElement(react_bootstrap_1.Col, { md: 2, className: "grandtotal" }, utils_1.moneyFormat(grandTotal))));
};

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(25);
var utils_1 = __webpack_require__(38);
exports.states = [{ code: "AL", name: "Alabama" }, { code: "AK", name: "Alaska" }, { code: "AZ", name: "Arizona" }, { code: "AR", name: "Arkansas" }, { code: "CA", name: "California" }, { code: "CO", name: "Colorado" }, { code: "CT", name: "Connecticut" }, { code: "DE", name: "Delaware" }, { code: "DC", name: "District Of Columbia" }, { code: "FL", name: "Florida" }, { code: "GA", name: "Georgia" }, { code: "HI", name: "Hawaii" }, { code: "ID", name: "Idaho" }, { code: "IL", name: "Illinois" }, { code: "IN", name: "Indiana" }, { code: "IA", name: "Iowa" }, { code: "KS", name: "Kansas" }, { code: "KY", name: "Kentucky" }, { code: "LA", name: "Louisiana" }, { code: "ME", name: "Maine" }, { code: "MD", name: "Maryland" }, { code: "MA", name: "Massachusetts" }, { code: "MI", name: "Michigan" }, { code: "MN", name: "Minnesota" }, { code: "MS", name: "Mississippi" }, { code: "MO", name: "Missouri" }, { code: "MT", name: "Montana" }, { code: "NE", name: "Nebraska" }, { code: "NV", name: "Nevada" }, { code: "NH", name: "New Hampshire" }, { code: "NJ", name: "New Jersey" }, { code: "NM", name: "New Mexico" }, { code: "NY", name: "New York" }, { code: "NC", name: "North Carolina" }, { code: "ND", name: "North Dakota" }, { code: "OH", name: "Ohio" }, { code: "OK", name: "Oklahoma" }, { code: "OR", name: "Oregon" }, { code: "PA", name: "Pennsylvania" }, { code: "RI", name: "Rhode Island" }, { code: "SC", name: "South Carolina" }, { code: "SD", name: "South Dakota" }, { code: "TN", name: "Tennessee" }, { code: "TX", name: "Texas" }, { code: "UT", name: "Utah" }, { code: "VT", name: "Vermont" }, { code: "VA", name: "Virginia" }, { code: "WA", name: "Washington" }, { code: "WV", name: "West Virginia" }, { code: "WI", name: "Wisconsin" }, { code: "WY", name: "Wyoming" }];
exports.ccImages = {
    visa: "data:image/gif;base64,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",
    amex: "data:image/gif;base64,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",
    mastercard: "data:image/gif;base64,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",
    discover: "data:image/gif;base64,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"
};
exports.titles = [{ code: "Mr.", name: "Mr." }, { code: "Ms.", name: "Ms." }, { code: "Mrs.", name: "Mrs." }, { code: "Dr.", name: "Dr." }];
exports.suffixes = [{ code: "Jr.", name: "Jr." }, { code: "Sr.", name: "Sr." }, { code: "I", name: "I" }, { code: "II", name: "II" }, { code: "III", name: "III" }, { code: "IV", name: "IV" }, { code: "V", name: "V" }];
exports.tripInsurances = lodash_1.range(1, 8).map(function (n) {
    return {
        name: n + " Ticket" + (n > 1 ? "s" : "") + " (" + utils_1.moneyFormat(n * 5) + ")",
        code: n
    };
});
exports.deliveryOptions = [{
    code: "Will Call",
    name: "(FREE) Will Call pick-up (photo ID required). Located outside all 4 Walt Disney World® Resort Park entrances."
}, {
    code: "U.S. Domestic Standard",
    name: "(FREE) U.S. Domestic Standard (Your arrival date must be at least 15 days from today's date)."
}, {
    code: "Express Mail",
    name: "($7) Express Mail (Your arrival date must be 10 days from today's date, U.S.A. orders only)."
}];
exports.MemoryMakerOptions = [{ code: "0", name: "No" }, { code: "1", name: "Yes, add Memory Maker for $185" }];
exports.GeniePlusOptions = [{ code: "0", name: "No" }, { code: "1", name: "Yes, add Genie+ for $16 per ticket per day" }];
exports.ticketNames = [{ code: "One Park Per Day", name: "One Park Per Day" }, { code: "Park Hopper®", name: "Park Hopper®" }, { code: "Park Hopper® Plus Option", name: "Park Hopper® Plus Option" }];
exports.destinations = [{ name: "Disneyland® Resort", code: "Disneyland Resort" }, { name: "Walt Disney World® Resort", code: "Walt Disney World Resort" }];

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
exports.API_VERSION = "v1";
function apiBase() {
    return "/api/" + exports.API_VERSION;
}
exports.apiBase = apiBase;

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(73);
exports.DISCOUNTS_LOADING = "DISCOUNTS_LOADING";
exports.DISCOUNTS_LOADED = "DISCOUNTS_LOADED";
exports.DISCOUNTS_API_ERROR = "DISCOUNTS_API_ERROR";
exports.DISCOUNTS_UPDATE_NEW = "DISCOUNTS_UPDATE_NEW";
exports.DISCOUNTS_SAVE_LOADING = "DISCOUNTS_SAVE_LOADING";
exports.DISCOUNTS_SAVED = "DISCOUNTS_SAVED";
exports.DISCOUNTS_UPDATED = "DISCOUNTS_UPDATED";
exports.DISCOUNTS_DELETED = "DISCOUNTS_DELETED";
exports.getDiscountList = function () {
    return function (dispatch) {
        dispatch({ type: exports.DISCOUNTS_LOADING });
        return common_1.apiRequest("/discounts").then(function (response) {
            return dispatch({
                type: exports.DISCOUNTS_LOADED,
                discounts: response
            });
        }).catch(function (err) {
            return dispatch(common_1.apiError(exports.DISCOUNTS_API_ERROR, err));
        });
    };
};
exports.updateNewDiscount = function (discount) {
    return {
        type: exports.DISCOUNTS_UPDATE_NEW, newDiscount: discount
    };
};
exports.saveNewDiscount = function (discount) {
    return function (dispatch) {
        dispatch({ type: exports.DISCOUNTS_SAVE_LOADING });
        return common_1.apiPost("/discounts", discount).then(function (response) {
            return dispatch({
                type: exports.DISCOUNTS_SAVED,
                newDiscount: response
            });
        }).catch(function (err) {
            return dispatch(common_1.apiError(exports.DISCOUNTS_API_ERROR, err));
        });
    };
};
exports.updateDiscount = function (discount) {
    return function (dispatch) {
        dispatch({ type: exports.DISCOUNTS_SAVE_LOADING });
        return common_1.apiPut("/discounts/" + discount.id, discount).then(function (response) {
            return dispatch({
                type: exports.DISCOUNTS_UPDATED,
                newDiscount: response
            });
        }).catch(function (err) {
            return dispatch(common_1.apiError(exports.DISCOUNTS_API_ERROR, err));
        });
    };
};
exports.deleteDiscount = function (discount) {
    return function (dispatch) {
        dispatch({ type: exports.DISCOUNTS_SAVE_LOADING });
        return common_1.apiDelete("/discounts/" + discount.id).then(function (response) {
            return dispatch({
                type: exports.DISCOUNTS_DELETED,
                newDiscount: discount
            });
        }).catch(function (err) {
            return dispatch(common_1.apiError(exports.DISCOUNTS_API_ERROR, err));
        });
    };
};

/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(73);
exports.TICKETS_LOADING = "TICKETS_LOADING";
exports.TICKETS_LOADED = "TICKETS_LOADED";
exports.TICKETS_API_ERROR = "TICKETS_API_ERROR";
exports.TICKETS_UPDATE_NEW = "TICKETS_UPDATE_NEW";
exports.TICKETS_SAVE_LOADING = "TICKETS_SAVE_LOADING";
exports.TICKETS_SAVED = "TICKETS_SAVED";
exports.TICKETS_UPDATED = "TICKETS_UPDATED";
exports.TICKETS_DELETED = "TICKETS_DELETED";
exports.TICKETS_SHOW_INACTIVE = "TICKETS_SHOW_INACTIVE";
exports.DELTA_UPDATE_NEW = "DELTA_UPDATE_NEW";
exports.DELTA_LOADED = "DELTA_LOADED";
exports.DELTA_SAVED = "DELTA_SAVED";
exports.DELTA_UPDATED = "DELTA_UPDATED";
exports.DELTA_DELETED = "DELTA_DELETED";
exports.getTicketList = function () {
    return function (dispatch) {
        dispatch({ type: exports.TICKETS_LOADING });
        return common_1.apiRequest("/tickets/all").then(function (response) {
            return dispatch({
                type: exports.TICKETS_LOADED,
                tickets: response
            });
        }).catch(function (err) {
            return dispatch(common_1.apiError(exports.TICKETS_API_ERROR, err));
        });
    };
};
exports.updateNewTicket = function (ticket) {
    return {
        type: exports.TICKETS_UPDATE_NEW, newTicket: ticket
    };
};
exports.saveNewTicket = function (ticket) {
    return function (dispatch) {
        dispatch({ type: exports.TICKETS_SAVE_LOADING });
        return common_1.apiPost("/tickets", ticket).then(function (response) {
            return dispatch({
                type: exports.TICKETS_SAVED,
                newTicket: response
            });
        }).catch(function (err) {
            return dispatch(common_1.apiError(exports.TICKETS_API_ERROR, err));
        });
    };
};
exports.updateTicket = function (ticket) {
    return function (dispatch) {
        dispatch({ type: exports.TICKETS_SAVE_LOADING });
        return common_1.apiPut("/tickets/" + ticket.id, ticket).then(function (response) {
            return dispatch({
                type: exports.TICKETS_UPDATED,
                newTicket: response
            });
        }).catch(function (err) {
            return dispatch(common_1.apiError(exports.TICKETS_API_ERROR, err));
        });
    };
};
exports.deleteTicket = function (ticket) {
    return function (dispatch) {
        dispatch({ type: exports.TICKETS_SAVE_LOADING });
        return common_1.apiDelete("/tickets/" + ticket.id).then(function (response) {
            return dispatch({
                type: exports.TICKETS_DELETED,
                newDiscount: ticket
            });
        }).catch(function (err) {
            return dispatch(common_1.apiError(exports.TICKETS_API_ERROR, err));
        });
    };
};
exports.setShowInactive = function (show) {
    return {
        type: exports.TICKETS_SHOW_INACTIVE, showInactive: show
    };
};
////// DELTAS
exports.getDeltaList = function () {
    return function (dispatch) {
        dispatch({ type: exports.TICKETS_LOADING });
        return common_1.apiRequest("/tickets/deltas").then(function (response) {
            return dispatch({
                type: exports.DELTA_LOADED,
                deltas: response
            });
        }).catch(function (err) {
            return dispatch(common_1.apiError(exports.TICKETS_API_ERROR, err));
        });
    };
};
exports.updateNewDelta = function (delta) {
    return {
        type: exports.DELTA_UPDATE_NEW, newDelta: delta
    };
};
exports.saveNewDelta = function (delta) {
    return function (dispatch) {
        dispatch({ type: exports.TICKETS_SAVE_LOADING });
        return common_1.apiPost("/tickets/deltas", delta).then(function (response) {
            return dispatch({
                type: exports.DELTA_SAVED,
                newDelta: response
            });
        }).catch(function (err) {
            return dispatch(common_1.apiError(exports.TICKETS_API_ERROR, err));
        });
    };
};
exports.updateDelta = function (delta) {
    return function (dispatch) {
        dispatch({ type: exports.TICKETS_SAVE_LOADING });
        return common_1.apiPut("/tickets/deltas/" + delta.id, delta).then(function (response) {
            return dispatch({
                type: exports.DELTA_UPDATED,
                newDelta: response
            });
        }).catch(function (err) {
            return dispatch(common_1.apiError(exports.TICKETS_API_ERROR, err));
        });
    };
};
exports.deleteDelta = function (delta) {
    return function (dispatch) {
        dispatch({ type: exports.TICKETS_SAVE_LOADING });
        return common_1.apiDelete("/tickets/deltas/" + delta.id).then(function () {
            return dispatch({
                type: exports.DELTA_DELETED,
                newDelta: delta
            });
        }).catch(function (err) {
            return dispatch(common_1.apiError(exports.TICKETS_API_ERROR, err));
        });
    };
};

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var hotels_1 = __webpack_require__(107);
var moment = __webpack_require__(1);
var lodash_1 = __webpack_require__(25);
function convertOrderResponse(response) {
    var hotels = lodash_1.map(response.hotel, function (ho) {
        return Object.assign({}, ho, { checkIn: moment(ho.checkIn), checkOut: moment(ho.checkOut) });
    });
    return Object.assign({}, response, { hotel: hotels, search: hotels_1.convertSearchResponse(response.search) });
}
exports.convertOrderResponse = convertOrderResponse;
function prepOrderConfirmation(response) {
    return {
        id: response.id,
        orderStatus: response.orderStatus,
        orderNumber: response.orderNumber,
        tickets: [],
        guests: [],
        ticketsSelected: false,
        transactions: [],
        lastRequest: moment(),
        hotel: [],
        search: {},
        user: response.user
    };
}
exports.prepOrderConfirmation = prepOrderConfirmation;
exports.defaultDiscountCode = function () {
    return {
        name: "",
        activeFrom: "",
        activeTo: "",
        active: true
    };
};

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(853);
var lodash_1 = __webpack_require__(25);
var common_1 = __webpack_require__(73);
var order_1 = __webpack_require__(252);
var utils_1 = __webpack_require__(38);
exports.HOTEL_LOADING = "HOTEL_LOADING";
exports.HOTEL_SEARCH_LOADING = "HOTEL_SEARCH_LOADING";
exports.HOTEL_SEARCH_RESULTS = "HOTEL_SEARCH_RESULTS";
exports.HOTEL_DETAIL = "HOTEL_DETAIL";
exports.HOTEL_UPDATE_SEARCH = "HOTEL_UPDATE_SEARCH";
exports.HOTEL_EDIT_AGES = "HOTEL_EDIT_AGES";
exports.HOTEL_ORDER_LOADING = "HOTEL_ORDER_LOADING";
exports.HOTEL_UPDATE_ORDER = "HOTEL_UPDATE_ORDER";
exports.HOTEL_UPDATE_FILTERS = "HOTEL_UPDATE_FILTERS";
exports.HOTEL_UPDATE_VALIDATION_ERROR = "HOTEL_UPDATE_VALIDATION_ERROR";
exports.HOTEL_API_ERROR = "HOTEL_API_ERROR";
exports.HOTEL_UPDATE_DISCOUNT_CODE = "HOTEL_UPDATE_DISCOUNT_CODE";
exports.HOTEL_DISCOUNT_LOADING = "HOTEL_DISCOUNT_LOADING";
exports.HOTEL_CHECK_DISCOUNT_CODE = "HOTEL_CHECK_DISCOUNT_CODE";
exports.HOTEL_RESET_ORDER = "HOTEL_RESET_ORDER";
exports.HOTEL_GET_TICKET_PRICE = "HOTEL_GET_TICKET_PRICE";
exports.HOTEL_GET_TICKET_PRICE_LOADING = "HOTEL_GET_TICKET_PRICE_LOADING";
exports.HOTEL_PAUSE_ORDERING = "HOTEL_PAUSE_ORDERING";
exports.HOTEL_SET_TICKET_PRICE_INFO = "HOTEL_SET_TICKET_PRICE_INFO";
function prepareSearchPayload(search) {
    var searchPayload = lodash_1.cloneDeep(search);
    searchPayload.checkIn = search.checkIn.format(utils_1.LOCAL_DATE_FMT);
    searchPayload.checkOut = search.checkOut.format(utils_1.LOCAL_DATE_FMT);
    return searchPayload;
}
function prepareOrderPayload(order) {
    var orderPayload = lodash_1.cloneDeep(order);
    orderPayload.search = prepareSearchPayload(order.search);
    lodash_1.forEach(orderPayload.hotel, function (ho) {
        ho.checkIn = ho.checkIn.format(utils_1.LOCAL_DATE_FMT);
        ho.checkOut = ho.checkOut.format(utils_1.LOCAL_DATE_FMT);
    });
    return orderPayload;
}
function applySearchCriteriaUpdate(search, router) {
    return function (dispatch) {
        // If we're on the hotel detail page, requery the detail
        if (router.match.path.indexOf("/hotels/") > -1 && router.match.params.id) {
            return dispatch(hotelDetail(router.match.params.id));
        }
        // Hotel search page
        if (router.match.path.indexOf("/hotels") > -1 && !router.match.params.id) {
            return dispatch(searchHotels(search));
        }
    };
}
exports.applySearchCriteriaUpdate = applySearchCriteriaUpdate;
function searchHotels(search) {
    return function (dispatch) {
        dispatch(loading(true));
        return common_1.apiPost("/packages/search", prepareSearchPayload(search)).then(function (response) {
            var listings = response.listings,
                order = response.order;

            return dispatch({
                type: exports.HOTEL_SEARCH_RESULTS,
                searchResults: listings,
                order: order_1.convertOrderResponse(order)
            });
        }).catch(function (err) {
            return dispatch(common_1.apiError(exports.HOTEL_API_ERROR, err));
        });
    };
}
exports.searchHotels = searchHotels;
function updateSearch(search) {
    utils_1.localStorageSet(exports.HOTEL_UPDATE_SEARCH, JSON.stringify(search));
    return { searchCriteria: search, type: exports.HOTEL_UPDATE_SEARCH };
}
exports.updateSearch = updateSearch;
function updateNumChildren(search, n) {
    var crit = lodash_1.cloneDeep(search);
    var diff = n - crit.childAges.length;
    if (diff < 0) {
        crit.childAges.splice(n, -diff);
    } else if (diff > 0) {
        lodash_1.range(diff).forEach(function () {
            return crit.childAges.push(-1);
        });
    }
    return crit;
}
exports.updateNumChildren = updateNumChildren;
function hotelDetail(id) {
    return function (dispatch, getState) {
        dispatch(loading(true));
        var searchPayload = prepareSearchPayload(getState().hotels.searchCriteria);
        return common_1.apiPost("/packages/hotel/" + id, searchPayload).then(function (response) {
            var order = response.order,
                hotel = response.hotel;

            return dispatch({
                type: exports.HOTEL_DETAIL,
                hotel: hotel,
                order: order_1.convertOrderResponse(order)
            });
        }).catch(function (err) {
            return dispatch(common_1.apiError(exports.HOTEL_API_ERROR, err));
        });
    };
}
exports.hotelDetail = hotelDetail;
function loading(isLoading) {
    return { loading: isLoading, type: exports.HOTEL_LOADING };
}
exports.loading = loading;
function editAges(isOpen) {
    return { editAgesOpen: isOpen, type: exports.HOTEL_EDIT_AGES };
}
exports.editAges = editAges;
function searchLoading(isLoading) {
    return { loading: isLoading, type: exports.HOTEL_SEARCH_LOADING };
}
exports.searchLoading = searchLoading;
function validationError(msg) {
    return { validationError: msg, type: exports.HOTEL_UPDATE_VALIDATION_ERROR };
}
exports.validationError = validationError;
function loadLatestOrder() {
    return function (dispatch) {
        var formParam = "";
        if (window && window.location && window.location.search) {
            var match = /form=([a-zA-Z0-9]+)/.exec(window.location.search);
            if (match && match.length > 1) {
                formParam = "?form=" + match[1];
            }
        }
        dispatch(searchLoading(true));
        return common_1.apiRequest("/orders/cart" + formParam).then(function (orderResponse) {
            var order = order_1.convertOrderResponse(orderResponse);
            dispatch(updateSearch(order.search));
            return dispatch({
                type: exports.HOTEL_UPDATE_ORDER,
                order: order
            });
        }).catch(function (err) {
            return dispatch(common_1.apiError(exports.HOTEL_API_ERROR, err));
        });
    };
}
exports.loadLatestOrder = loadLatestOrder;
function orderLoading(isLoading) {
    return { loading: isLoading, type: exports.HOTEL_ORDER_LOADING };
}
exports.orderLoading = orderLoading;
function updateOrder(order) {
    return function (dispatch) {
        //dispatch(orderLoading(true));
        return common_1.apiPost("/orders/cart", prepareOrderPayload(order)).then(function (response) {
            if (response.isValid) {
                return dispatch({
                    type: exports.HOTEL_UPDATE_ORDER,
                    order: order_1.convertOrderResponse(response.order)
                });
            } else {
                return dispatch({
                    type: exports.HOTEL_RESET_ORDER,
                    validationError: response.validationErrorMessage
                });
            }
        }).catch(function (err) {
            return dispatch(common_1.apiError(exports.HOTEL_API_ERROR, err));
        });
    };
}
exports.updateOrder = updateOrder;
function validateCompletedOrder(order) {
    return function (dispatch) {
        dispatch(orderLoading(true));
        return common_1.apiPost("/orders/cart/validate", prepareOrderPayload(order)).then(function (response) {
            if (response.isValid) {
                return dispatch({
                    type: exports.HOTEL_UPDATE_ORDER,
                    order: order_1.convertOrderResponse(response.order)
                });
            } else {
                return dispatch({
                    type: exports.HOTEL_UPDATE_VALIDATION_ERROR,
                    validationError: response.validationErrorMessage
                });
            }
        }).catch(function (err) {
            return dispatch(common_1.apiError(exports.HOTEL_API_ERROR, err));
        });
    };
}
exports.validateCompletedOrder = validateCompletedOrder;
function placeOrder(order) {
    return function (dispatch) {
        dispatch(orderLoading(true));
        return common_1.apiPost("/orders", prepareOrderPayload(order)).then(function (response) {
            if (response.isValid) {
                return dispatch({
                    type: exports.HOTEL_UPDATE_ORDER,
                    order: order_1.prepOrderConfirmation(response.order)
                });
            } else {
                return dispatch({
                    type: exports.HOTEL_UPDATE_VALIDATION_ERROR,
                    validationError: response.validationErrorMessage
                });
            }
        }).catch(function (err) {
            return dispatch(common_1.apiError(exports.HOTEL_API_ERROR, err));
        });
    };
}
exports.placeOrder = placeOrder;
function updateFilters(filters) {
    return { filters: filters, type: exports.HOTEL_UPDATE_FILTERS };
}
exports.updateFilters = updateFilters;
function updateOrderStore(order) {
    return {
        type: exports.HOTEL_UPDATE_ORDER,
        order: lodash_1.clone(order)
    };
}
exports.updateOrderStore = updateOrderStore;
function updateDiscountCode(code) {
    return {
        type: exports.HOTEL_UPDATE_DISCOUNT_CODE,
        newDiscountCode: code
    };
}
exports.updateDiscountCode = updateDiscountCode;
exports.discountLoading = function (loading) {
    return { type: exports.HOTEL_DISCOUNT_LOADING, discountCodeLoading: loading };
};
exports.discountMessage = function (msg, success) {
    return {
        type: exports.HOTEL_CHECK_DISCOUNT_CODE,
        discountCodeMessage: msg,
        newDiscountSuccess: success
    };
};
function removeDiscountCode(orderDiscount) {
    return function (dispatch, getState) {
        var order = getState().hotels.order;
        var ix = order.discounts.indexOf(orderDiscount);
        if (ix > -1) {
            order.discounts.splice(ix, 1);
        }
        return dispatch(updateOrder(order)).then(function () {
            return dispatch(exports.discountMessage(orderDiscount.discountName + " removed", false));
        });
    };
}
exports.removeDiscountCode = removeDiscountCode;
function checkDiscountCode(code) {
    return function (dispatch, getState) {
        dispatch(exports.discountLoading(true));
        return common_1.apiRequest("/discounts/lookup/" + encodeURIComponent(code)).then(function (response) {
            // Got a good code, apply it to the order
            var order = getState().hotels.order;
            order.discounts.push({
                discountId: response.id,
                discountName: response.name
            });
            return dispatch(updateOrder(order)).then(function () {
                return dispatch(exports.discountMessage("Successfully applied discount code " + code, true));
            });
        }).catch(function (err) {
            return dispatch(exports.discountMessage("Invalid discount code " + code, false));
        });
    };
}
exports.checkDiscountCode = checkDiscountCode;
exports.getTicketPrice = function (orderTicket) {
    return { type: exports.HOTEL_GET_TICKET_PRICE, orderTicket: orderTicket };
};
exports.loadingTicketPrice = function (loading) {
    return { type: exports.HOTEL_GET_TICKET_PRICE_LOADING, orderTicketLoading: loading };
};
exports.setPauseOrdering = function (paused) {
    return { type: exports.HOTEL_PAUSE_ORDERING, pauseOrdering: paused };
};
exports.setTicketPriceInfo = function (info) {
    return { type: exports.HOTEL_SET_TICKET_PRICE_INFO, orderTicketPriceInfo: info };
};
function loadOrderTicketPrice(orderTicket) {
    return function (dispatch, state) {
        dispatch(exports.loadingTicketPrice(true));
        var form = lodash_1.get(state(), "hotels.order.form");
        var formParam = form ? "?form=" + form : "";
        return common_1.apiPost("/tickets/price" + formParam, orderTicket).then(function (response) {
            return dispatch(exports.setTicketPriceInfo(response));
        }).catch(function (err) {
            dispatch(exports.loadingTicketPrice(false));
            return dispatch(common_1.apiError(exports.HOTEL_API_ERROR, err));
        });
    };
}
exports.loadOrderTicketPrice = loadOrderTicketPrice;

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(25);
exports.LOCAL_DATE_FMT = "YYYY-MM-DD";
function moneyFormat(n) {
    var sign = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "$";

    if (lodash_1.isNaN(n)) {
        return n + "";
    }
    var pieces = parseFloat(n).toFixed(2).split("");
    var ii = pieces.length - 6;
    while (ii > 0) {
        pieces.splice(ii, 0, ",");
        ii -= 3;
    }
    return sign + pieces.join("");
}
exports.moneyFormat = moneyFormat;
exports.ZERO_TOTALS = {
    subTotal: 0.0,
    taxTotal: 0.0,
    discountTotal: 0.0,
    grandTotal: 0.0
};
function ticketsForDestination(tickets, destination) {
    var destinationTickets = lodash_1.filter(tickets, function (t) {
        return t.destination === destination;
    });
    destinationTickets.sort(function (a, b) {
        var dc = a.days - b.days;
        if (dc === 0) {
            return a.name.localeCompare(b.name);
        }
        return dc;
    });
    return destinationTickets;
}
exports.ticketsForDestination = ticketsForDestination;

var Future = function Future() {
    var _this = this;

    _classCallCheck(this, Future);

    this.promise = new Promise(function (resolve, reject) {
        _this.resolve = resolve;
        _this.reject = reject;
    });
};

exports.Future = Future;
function parentFrameScrollToTop() {
    if (window.self === window.top || !window.__ifid) {
        return;
    }
    try {
        window.top.postMessage(JSON.stringify({
            scrollToTop: true,
            id: window.__ifid
        }), "*");
    } catch (err) {
        if (console) {
            console.log(err);
        }
    }
}
exports.parentFrameScrollToTop = parentFrameScrollToTop;
function localStorageSet(key, value) {
    try {
        window.localStorage.setItem(key, value);
    } catch (e) {
        if (console) {
            console.log(e);
        }
    }
}
exports.localStorageSet = localStorageSet;
function localStorageGet(key) {
    try {
        return window.localStorage.getItem(key);
    } catch (e) {
        if (console) {
            console.log(e);
        }
    }
}
exports.localStorageGet = localStorageGet;
function localStorageRemove(key) {
    try {
        window.localStorage.removeItem(key);
    } catch (e) {
        if (console) {
            console.log(e);
        }
    }
}
exports.localStorageRemove = localStorageRemove;

/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_dom_1 = __webpack_require__(24);
var react_router_dom_1 = __webpack_require__(49);
var redux_1 = __webpack_require__(229);
var react_redux_1 = __webpack_require__(36);
var redux_thunk_1 = __webpack_require__(1054);
__webpack_require__(590);
var ReactGA = __webpack_require__(976);
var index_1 = __webpack_require__(586);
var hotels_1 = __webpack_require__(37);
var common_1 = __webpack_require__(73);
var Recaptcha_1 = __webpack_require__(571);
var Tickets_1 = __webpack_require__(575);
var Summary_1 = __webpack_require__(574);
var Checkout_1 = __webpack_require__(568);
var Review_1 = __webpack_require__(572);
var admin_1 = __webpack_require__(582);
var Header_1 = __webpack_require__(570);
var Confirm_1 = __webpack_require__(569);
var utils_1 = __webpack_require__(38);
var ReactPixel = __webpack_require__(975).default;
ReactGA.initialize("UA-74040302-3");
var store = redux_1.applyMiddleware(redux_thunk_1.default)(redux_1.createStore)(index_1.default);
ReactPixel.init("1353515278149259");
store.dispatch(hotels_1.loadLatestOrder());
store.dispatch(common_1.loadConfig());
store.dispatch(common_1.loadTickets());
var logPageView = function logPageView() {
    ReactGA.set({ page: window.location.pathname });
    ReactGA.pageview(window.location.pathname);
    utils_1.parentFrameScrollToTop();
    ReactPixel.pageView();
    if (window.location.pathname.indexOf("confirm") > -1) {
        ReactPixel.track("Purchase", { value: 0 });
    }
    return null;
};
react_dom_1.render(React.createElement(react_redux_1.Provider, { store: store }, React.createElement(react_router_dom_1.BrowserRouter, { basename: "wdwtickets" }, React.createElement("div", { className: "container main-container" }, React.createElement(react_router_dom_1.Route, { path: "/", component: logPageView }), React.createElement(Recaptcha_1.default, null), React.createElement(Header_1.Header, null), React.createElement(react_router_dom_1.Route, { exact: true, path: "/", component: Tickets_1.default }), React.createElement(react_router_dom_1.Route, { exact: true, path: "/tickets", component: Tickets_1.default }), React.createElement(react_router_dom_1.Route, { exact: true, path: "/summary", component: Summary_1.default }), React.createElement(react_router_dom_1.Route, { exact: true, path: "/checkout", component: Checkout_1.default }), React.createElement(react_router_dom_1.Route, { exact: true, path: "/review", component: Review_1.default }), React.createElement(react_router_dom_1.Route, { exact: true, path: "/confirm", component: Confirm_1.default }), React.createElement(react_router_dom_1.Route, { path: "/admin", component: admin_1.default }), React.createElement(Header_1.Footer, null)))), document.getElementById("app"));

/***/ }),

/***/ 514:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 568:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(36);
var react_router_dom_1 = __webpack_require__(49);
var react_bootstrap_1 = __webpack_require__(26);
var react_bootstrap_2 = __webpack_require__(26);
var lodash_1 = __webpack_require__(25);
__webpack_require__(62);
__webpack_require__(71);
__webpack_require__(98);
var moment = __webpack_require__(1);
var validator = __webpack_require__(591);
__webpack_require__(85);
var Cart_1 = __webpack_require__(127);
var hotels_1 = __webpack_require__(37);
var enums_1 = __webpack_require__(171);
var Loading_1 = __webpack_require__(91);
var PackageTotals_1 = __webpack_require__(170);

var Checkout = function (_React$Component) {
    _inherits(Checkout, _React$Component);

    function Checkout() {
        _classCallCheck(this, Checkout);

        return _possibleConstructorReturn(this, (Checkout.__proto__ || Object.getPrototypeOf(Checkout)).apply(this, arguments));
    }

    _createClass(Checkout, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps, nextContext) {
            if (nextProps.order && lodash_1.isEmpty(nextProps.order.tickets)) {
                this.props.history.push("/");
                return;
            }
        }
    }, {
        key: "render",
        value: function render() {
            return React.createElement("div", { className: "hotel-listing-c" }, React.createElement("div", { className: "package-container" }, React.createElement("div", { className: "checkout" }, this.renderCart(), this.renderCustomerInfoForm(), this.renderPaymentInformation())));
        }
    }, {
        key: "renderCart",
        value: function renderCart() {
            if (!this.props.order) {
                return null;
            }
            return React.createElement(react_bootstrap_1.Panel, { bsStyle: "primary", className: "cart" }, React.createElement(react_bootstrap_1.Panel.Heading, null, "Your Order"), React.createElement(react_bootstrap_1.Panel.Body, null, React.createElement(Cart_1.default, null), React.createElement("h3", null, "Guests"), this.renderGuestInfo(), React.createElement("h3", null, "Discount Codes"), this.renderDiscountCodes(), React.createElement("h3", null, "Totals"), React.createElement(PackageTotals_1.PackageTotals, { order: this.props.order })));
        }
    }, {
        key: "renderGuestInfo",
        value: function renderGuestInfo() {
            if (!this.props.order) {
                return null;
            }
            return React.createElement(react_bootstrap_1.Table, { striped: true, condensed: true }, React.createElement("thead", null, React.createElement("tr", null, React.createElement("th", null, "Guest"))), React.createElement("tbody", null, this.props.order.guests.map(function (guest, index) {
                return React.createElement("tr", { key: index }, React.createElement("td", null, guest.title, " ", guest.firstName, " ", guest.middleName, " ", guest.lastName, " ", guest.suffix));
            })));
        }
    }, {
        key: "renderDiscountCodes",
        value: function renderDiscountCodes() {
            var _this2 = this;

            if (!this.props.order) {
                return null;
            }
            var _props = this.props,
                newDiscountCode = _props.newDiscountCode,
                discountCodeMessage = _props.discountCodeMessage,
                discountCodeLoading = _props.discountCodeLoading,
                newDiscountSuccess = _props.newDiscountSuccess;

            var discounts = this.props.order.discounts;
            var discountMsg = null;
            if (discountCodeMessage) {
                discountMsg = React.createElement(react_bootstrap_1.Alert, { bsStyle: newDiscountSuccess ? "success" : "warning" }, discountCodeMessage);
            }
            return React.createElement("div", { className: "discounts" }, discounts.length > 0 && React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { md: 6 }, React.createElement(react_bootstrap_1.ListGroup, null, React.createElement(react_bootstrap_1.ListGroupItem, { active: true }, "Applied Discount Codes"), discounts.map(function (discount) {
                return React.createElement(react_bootstrap_1.ListGroupItem, { key: discount.discountId }, discount.discountName, React.createElement("i", { className: "fa fa-remove list-button", onClick: function onClick() {
                        return _this2.props.removeDiscountCode(discount);
                    } }));
            })))), discountCodeLoading ? React.createElement(Loading_1.Loading, { label: "Checking Code" }) : React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { md: 6 }, discountMsg, discounts.length === 0 && React.createElement(react_bootstrap_2.FormGroup, null, React.createElement(react_bootstrap_2.ControlLabel, null, "Apply a Discount Code to your Order"), React.createElement(react_bootstrap_2.FormControl, { type: "text", className: "discount-field", value: newDiscountCode, onChange: function onChange(e) {
                    return _this2.props.updateDiscountCode(e.target.value);
                } }), React.createElement(react_bootstrap_2.Button, { onClick: function onClick() {
                    return _this2.props.checkDiscountCode(newDiscountCode);
                } }, "Apply")))));
        }
    }, {
        key: "renderCustomerInfoForm",
        value: function renderCustomerInfoForm() {
            var _this3 = this;

            if (!this.props.order) {
                return null;
            }
            var order = this.props.order;
            var user = this.getNewUser();
            var shippingAddress = this.getAddress(order.shippingAddress);
            var billingAddress = this.getAddress(order.billingAddress);
            var shippingZipValidation = validator.postalCode(shippingAddress.zip);
            var billingZipValidation = validator.postalCode(billingAddress.zip);
            return React.createElement(react_bootstrap_1.Panel, { bsStyle: "primary" }, React.createElement(react_bootstrap_1.Panel.Heading, null, "Mailing Information"), React.createElement(react_bootstrap_1.Panel.Body, null, React.createElement(react_bootstrap_1.Col, { xs: 12 }, React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { md: 6 }, React.createElement(react_bootstrap_2.FormGroup, { validationState: Checkout.isNotEmpty(user.firstName) }, React.createElement(react_bootstrap_2.ControlLabel, null, "First Name *"), React.createElement(react_bootstrap_2.FormControl, { type: "text", value: user.firstName, onChange: function onChange(e) {
                    return _this3.updateUser(function (u) {
                        return u.firstName = e.target.value;
                    });
                } }), React.createElement(react_bootstrap_2.FormControl.Feedback, null))), React.createElement(react_bootstrap_1.Col, { md: 6 }, React.createElement(react_bootstrap_2.FormGroup, { validationState: Checkout.isNotEmpty(user.lastName) }, React.createElement(react_bootstrap_2.ControlLabel, null, "Last Name *"), React.createElement(react_bootstrap_2.FormControl, { type: "text", value: user.lastName, onChange: function onChange(e) {
                    return _this3.updateUser(function (u) {
                        return u.lastName = e.target.value;
                    });
                } }), React.createElement(react_bootstrap_2.FormControl.Feedback, null)))), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { md: 6 }, React.createElement(react_bootstrap_2.FormGroup, { validationState: Checkout.isNotEmpty(user.phoneNumber) }, React.createElement(react_bootstrap_2.ControlLabel, null, "Phone Number *"), React.createElement(react_bootstrap_2.FormControl, { type: "text", value: user.phoneNumber, onChange: function onChange(e) {
                    return _this3.updateUser(function (u) {
                        return u.phoneNumber = e.target.value;
                    });
                } }), React.createElement(react_bootstrap_2.FormControl.Feedback, null))), React.createElement(react_bootstrap_1.Col, { md: 6 }, React.createElement(react_bootstrap_2.FormGroup, { validationState: Checkout.isNotEmpty(user.email) }, React.createElement(react_bootstrap_2.ControlLabel, null, "Email Address *"), React.createElement(react_bootstrap_2.FormControl, { type: "text", value: user.email, onChange: function onChange(e) {
                    return _this3.updateUser(function (u) {
                        u.email = e.target.value;
                    });
                } }), React.createElement(react_bootstrap_2.FormControl.Feedback, null)))), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, null, React.createElement("h4", null, "Shipping Address"))), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { md: 6 }, React.createElement(react_bootstrap_2.FormGroup, { validationState: Checkout.isNotEmpty(shippingAddress.address1) }, React.createElement(react_bootstrap_2.ControlLabel, null, "Address Line 1 *"), React.createElement(react_bootstrap_2.FormControl, { type: "text", value: shippingAddress.address1, onChange: function onChange(e) {
                    return _this3.updateShippingAddress(function (u) {
                        return u.address1 = e.target.value;
                    });
                } }), React.createElement(react_bootstrap_2.FormControl.Feedback, null))), React.createElement(react_bootstrap_1.Col, { md: 6 }, React.createElement(react_bootstrap_2.FormGroup, { validationState: Checkout.isNotEmpty(shippingAddress.address2) }, React.createElement(react_bootstrap_2.ControlLabel, null, "Address Line 2"), React.createElement(react_bootstrap_2.FormControl, { type: "text", value: shippingAddress.address2, onChange: function onChange(e) {
                    return _this3.updateShippingAddress(function (u) {
                        return u.address2 = e.target.value;
                    });
                } }), React.createElement(react_bootstrap_2.FormControl.Feedback, null)))), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { md: 4 }, React.createElement(react_bootstrap_2.FormGroup, { validationState: Checkout.isNotEmpty(shippingAddress.city) }, React.createElement(react_bootstrap_2.ControlLabel, null, "City *"), React.createElement(react_bootstrap_2.FormControl, { type: "text", value: shippingAddress.city, onChange: function onChange(e) {
                    return _this3.updateShippingAddress(function (u) {
                        return u.city = e.target.value;
                    });
                } }), React.createElement(react_bootstrap_2.FormControl.Feedback, null))), React.createElement(react_bootstrap_1.Col, { md: 3 }, React.createElement(react_bootstrap_2.FormGroup, { validationState: Checkout.isNotEmpty(shippingAddress.state) }, React.createElement(react_bootstrap_2.ControlLabel, null, "State *"), React.createElement(react_bootstrap_2.FormControl, { componentClass: "select", value: shippingAddress.state, onChange: function onChange(e) {
                    return _this3.updateShippingAddress(function (u) {
                        return u.state = e.target.value;
                    });
                } }, React.createElement("option", { value: "", key: "--" }), lodash_1.map(enums_1.states, function (state) {
                return React.createElement("option", { value: state.code, key: state.code }, state.name);
            }), React.createElement("option", { value: "n/a", key: "n/a" }, "-- Outside US --")), React.createElement(react_bootstrap_2.FormControl.Feedback, null))), React.createElement(react_bootstrap_1.Col, { md: 2 }, React.createElement(react_bootstrap_2.FormGroup, { validationState: Checkout.validatorToState(shippingAddress.zip, shippingZipValidation) }, React.createElement(react_bootstrap_2.ControlLabel, null, "Postal Code *"), React.createElement(react_bootstrap_2.FormControl, { type: "text", value: shippingAddress.zip, onChange: function onChange(e) {
                    return _this3.updateShippingAddress(function (u) {
                        return u.zip = e.target.value;
                    });
                } }), React.createElement(react_bootstrap_2.FormControl.Feedback, null))), React.createElement(react_bootstrap_1.Col, { md: 3 }, React.createElement(react_bootstrap_2.FormGroup, { validationState: Checkout.isNotEmpty(shippingAddress.country) }, React.createElement(react_bootstrap_2.ControlLabel, null, "Country *"), React.createElement(react_bootstrap_2.FormControl, { type: "text", value: shippingAddress.country, onChange: function onChange(e) {
                    return _this3.updateShippingAddress(function (u) {
                        return u.country = e.target.value;
                    });
                } }), React.createElement(react_bootstrap_2.FormControl.Feedback, null)))), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, null, React.createElement("h4", null, "Billing Address"), React.createElement(react_bootstrap_2.FormGroup, null, React.createElement(react_bootstrap_2.Checkbox, { checked: order.billingSameAsShipping || false, onChange: function onChange(e) {
                    order.billingSameAsShipping = e.target.checked;
                    _this3.updateOrder(order);
                } }, "Billing address is the same as the shipping address")))), order.billingSameAsShipping ? null : React.createElement("div", null, React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { md: 6 }, React.createElement(react_bootstrap_2.FormGroup, { validationState: Checkout.isNotEmpty(billingAddress.address1) }, React.createElement(react_bootstrap_2.ControlLabel, null, "Address Line 1 *"), React.createElement(react_bootstrap_2.FormControl, { type: "text", value: billingAddress.address1, onChange: function onChange(e) {
                    return _this3.updateBillingAddress(function (u) {
                        return u.address1 = e.target.value;
                    });
                } }), React.createElement(react_bootstrap_2.FormControl.Feedback, null))), React.createElement(react_bootstrap_1.Col, { md: 6 }, React.createElement(react_bootstrap_2.FormGroup, { validationState: Checkout.isNotEmpty(billingAddress.address2) }, React.createElement(react_bootstrap_2.ControlLabel, null, "Address Line 2"), React.createElement(react_bootstrap_2.FormControl, { type: "text", value: billingAddress.address2, onChange: function onChange(e) {
                    return _this3.updateBillingAddress(function (u) {
                        return u.address2 = e.target.value;
                    });
                } }), React.createElement(react_bootstrap_2.FormControl.Feedback, null)))), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { md: 4 }, React.createElement(react_bootstrap_2.FormGroup, { validationState: Checkout.isNotEmpty(billingAddress.city) }, React.createElement(react_bootstrap_2.ControlLabel, null, "City *"), React.createElement(react_bootstrap_2.FormControl, { type: "text", value: billingAddress.city, onChange: function onChange(e) {
                    return _this3.updateBillingAddress(function (u) {
                        return u.city = e.target.value;
                    });
                } }), React.createElement(react_bootstrap_2.FormControl.Feedback, null))), React.createElement(react_bootstrap_1.Col, { md: 3 }, React.createElement(react_bootstrap_2.FormGroup, { validationState: Checkout.isNotEmpty(billingAddress.state) }, React.createElement(react_bootstrap_2.ControlLabel, null, "State *"), React.createElement(react_bootstrap_2.FormControl, { componentClass: "select", value: billingAddress.state, onChange: function onChange(e) {
                    return _this3.updateBillingAddress(function (u) {
                        return u.state = e.target.value;
                    });
                } }, React.createElement("option", { value: "", key: "--" }), lodash_1.map(enums_1.states, function (state) {
                return React.createElement("option", { value: state.code, key: state.code }, state.name);
            }), React.createElement("option", { value: "n/a", key: "n/a" }, "-- Outside US --")), React.createElement(react_bootstrap_2.FormControl.Feedback, null))), React.createElement(react_bootstrap_1.Col, { md: 2 }, React.createElement(react_bootstrap_2.FormGroup, { validationState: Checkout.validatorToState(billingAddress.zip, billingZipValidation) }, React.createElement(react_bootstrap_2.ControlLabel, null, "Postal Code *"), React.createElement(react_bootstrap_2.FormControl, { type: "text", value: billingAddress.zip, onChange: function onChange(e) {
                    return _this3.updateBillingAddress(function (u) {
                        return u.zip = e.target.value;
                    });
                } }), React.createElement(react_bootstrap_2.FormControl.Feedback, null))), React.createElement(react_bootstrap_1.Col, { md: 3 }, React.createElement(react_bootstrap_2.FormGroup, { validationState: Checkout.isNotEmpty(billingAddress.country) }, React.createElement(react_bootstrap_2.ControlLabel, null, "Country *"), React.createElement(react_bootstrap_2.FormControl, { type: "text", value: billingAddress.country, onChange: function onChange(e) {
                    return _this3.updateBillingAddress(function (u) {
                        return u.country = e.target.value;
                    });
                } }), React.createElement(react_bootstrap_2.FormControl.Feedback, null))))))));
        }
    }, {
        key: "renderPaymentInformation",
        value: function renderPaymentInformation() {
            var _this4 = this;

            if (!this.props.order) {
                return null;
            }
            var info = this.getPaymentInfo();

            var _validateForms = this.validateForms(),
                numberValidation = _validateForms.numberValidation,
                monthValidation = _validateForms.monthValidation,
                yearValidation = _validateForms.yearValidation,
                cvvValidation = _validateForms.cvvValidation,
                zipValidation = _validateForms.zipValidation;

            var cardImg = null;
            var cardName = null;
            if (info.cardType) {
                cardName = React.createElement("span", { className: "cc-type" }, info.cardType);
                cardImg = React.createElement("img", { className: "cc-image", src: Checkout.ccImageForValidatorType(info.cardType) });
            }
            return React.createElement(react_bootstrap_1.Panel, { bsStyle: "primary" }, React.createElement(react_bootstrap_1.Panel.Heading, null, "Payment Information"), React.createElement(react_bootstrap_1.Panel.Body, null, React.createElement(react_bootstrap_1.Col, { xs: 12 }, React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { md: 4 }, React.createElement(react_bootstrap_2.FormGroup, { validationState: Checkout.isNotEmpty(info.cardFirstName) }, React.createElement(react_bootstrap_2.ControlLabel, null, "Card First Name *"), React.createElement(react_bootstrap_2.FormControl, { type: "text", value: info.cardFirstName, onChange: function onChange(e) {
                    return _this4.updatePaymentInfo(function (u) {
                        return u.cardFirstName = e.target.value;
                    });
                } }), React.createElement(react_bootstrap_2.FormControl.Feedback, null))), React.createElement(react_bootstrap_1.Col, { md: 4 }, React.createElement(react_bootstrap_2.FormGroup, { validationState: Checkout.isNotEmpty(info.cardLastName) }, React.createElement(react_bootstrap_2.ControlLabel, null, "Card Last Name *"), React.createElement(react_bootstrap_2.FormControl, { type: "text", value: info.cardLastName, onChange: function onChange(e) {
                    return _this4.updatePaymentInfo(function (u) {
                        return u.cardLastName = e.target.value;
                    });
                } }), React.createElement(react_bootstrap_2.FormControl.Feedback, null))), React.createElement(react_bootstrap_1.Col, { md: 4 }, React.createElement(react_bootstrap_2.FormGroup, { validationState: Checkout.validatorToState(info.ccNum, numberValidation) }, React.createElement(react_bootstrap_2.ControlLabel, null, "Card Number *"), React.createElement(react_bootstrap_2.FormControl, { type: "text", value: info.ccNum, onChange: function onChange(e) {
                    return _this4.updatePaymentInfo(function (u) {
                        u.ccNum = e.target.value;
                        if (numberValidation.card && numberValidation.card.type) {
                            u.cardType = numberValidation.card.type;
                        }
                    });
                } }), React.createElement(react_bootstrap_2.FormControl.Feedback, null), React.createElement("div", { style: { textAlign: "right", marginTop: "10px" } }, cardName, " ", cardImg)))), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { md: 2 }, React.createElement(react_bootstrap_2.FormGroup, { validationState: Checkout.validatorToState(info.cvv2, cvvValidation) }, React.createElement(react_bootstrap_2.ControlLabel, null, "Card ID / CVV2 *"), React.createElement(react_bootstrap_2.FormControl, { type: "text", value: info.cvv2, onChange: function onChange(e) {
                    return _this4.updatePaymentInfo(function (u) {
                        return u.cvv2 = e.target.value;
                    });
                } }), React.createElement(react_bootstrap_2.FormControl.Feedback, null))), React.createElement(react_bootstrap_1.Col, { md: 3 }, React.createElement(react_bootstrap_2.FormGroup, { validationState: Checkout.validatorToState(info.expMonth, monthValidation) }, React.createElement(react_bootstrap_2.ControlLabel, null, "Card Expiration Month *"), React.createElement(react_bootstrap_2.FormControl, { componentClass: "select", value: info.expMonth, onChange: function onChange(e) {
                    return _this4.updatePaymentInfo(function (u) {
                        return u.expMonth = e.target.value;
                    });
                } }, React.createElement("option", { value: null }), lodash_1.map(lodash_1.range(1, 13), function (month) {
                return React.createElement("option", { value: month, key: month }, moment("2000-" + month, "YYYY-M").format("MM - MMMM"));
            })), React.createElement(react_bootstrap_2.FormControl.Feedback, null))), React.createElement(react_bootstrap_1.Col, { md: 3 }, React.createElement(react_bootstrap_2.FormGroup, { validationState: Checkout.validatorToState(info.expYear, yearValidation) }, React.createElement(react_bootstrap_2.ControlLabel, null, "Card Expiration Year *"), React.createElement(react_bootstrap_2.FormControl, { componentClass: "select", value: info.expYear, onChange: function onChange(e) {
                    return _this4.updatePaymentInfo(function (u) {
                        return u.expYear = e.target.value;
                    });
                } }, React.createElement("option", { value: "" }), lodash_1.map(lodash_1.range(0, 10), function (i) {
                var y = moment().add(i, "years");
                var year = y.year();
                return React.createElement("option", { value: year, key: year }, year);
            })), React.createElement(react_bootstrap_2.FormControl.Feedback, null))), React.createElement(react_bootstrap_1.Col, { md: 2 }, React.createElement(react_bootstrap_2.FormGroup, null, React.createElement(react_bootstrap_2.ControlLabel, null, "Card Type *"), React.createElement(react_bootstrap_2.FormControl, { componentClass: "select", value: info.cardType, onChange: function onChange(e) {
                    return _this4.updatePaymentInfo(function (u) {
                        return u.cardType = e.target.value;
                    });
                } }, React.createElement("option", { value: "" }), lodash_1.map(["visa", "master-card", "american-express", "discover"], function (ct) {
                return React.createElement("option", { value: ct, key: ct }, ct);
            })), React.createElement(react_bootstrap_2.FormControl.Feedback, null))), React.createElement(react_bootstrap_1.Col, { md: 2 }, React.createElement(react_bootstrap_2.FormGroup, { validationState: Checkout.validatorToState(info.zipCode, zipValidation) }, React.createElement(react_bootstrap_2.ControlLabel, null, "Billing Zip Code *"), React.createElement(react_bootstrap_2.FormControl, { type: "text", value: info.zipCode, onChange: function onChange(e) {
                    return _this4.updatePaymentInfo(function (u) {
                        return u.zipCode = e.target.value;
                    });
                } }), React.createElement(react_bootstrap_2.FormControl.Feedback, null)))), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { xs: 12, style: { textAlign: "center", marginTop: "20px" } }, (this.props.validationErrorMessage || this.props.errorMessage) && React.createElement(react_bootstrap_1.Alert, { bsStyle: "danger" }, this.props.validationErrorMessage, this.props.errorMessage), React.createElement(react_bootstrap_2.Button, { bsStyle: "success", bsSize: "lg", onClick: function onClick() {
                    return _this4.validateAndUpdateOrder();
                } }, "Review Order"))))));
        }
    }, {
        key: "validateAndUpdateOrder",
        value: function validateAndUpdateOrder() {
            var _this5 = this;

            var results = this.validateForms();
            if (!lodash_1.isEmpty(results.emptyFields)) {
                // return this.props.validationError("Please fill in all required fields");
            }
            if (!(results.userZipValidation.isValid && results.cvvValidation.isValid && results.monthValidation.isValid && results.yearValidation.isValid && results.zipValidation.isValid)) {
                // return this.props.validationError("Some required fields are invalid");
            }
            this.props.validateCompletedOrder(this.props.order).then(function (action) {
                if (!action.validationError) {
                    _this5.props.history.push("/review");
                }
            });
        }
    }, {
        key: "validateForms",
        value: function validateForms() {
            var user = this.getNewUser();
            var order = this.props.order;
            var shippingAddress = this.getAddress(order.shippingAddress);
            var billingAddress = this.getAddress(order.billingAddress);
            var info = this.getPaymentInfo();
            var numberValidation = validator.number(info.ccNum);
            var emptyFields = {};
            var emptyCheck = function emptyCheck(o, k) {
                var v = o[k];
                if (lodash_1.isNull(v) || lodash_1.isUndefined(v) || lodash_1.isEmpty(v) && lodash_1.isString(v)) {
                    emptyFields[k] = true;
                }
            };
            lodash_1.map(["email", "firstName", "lastName", "phoneNumber"], function (k) {
                return emptyCheck(user, k);
            });
            lodash_1.map(["address1", "city", "state", "zip"], function (k) {
                return emptyCheck(shippingAddress, k);
            });
            if (!order.billingSameAsShipping) {
                lodash_1.map(["address1", "city", "state", "zip"], function (k) {
                    return emptyCheck(billingAddress, k);
                });
            }
            lodash_1.map(["cardFirstName", "cardLastName", "ccNum", "cardType", "expMonth", "expYear", "zipCode", "cvv2"], function (k) {
                return emptyCheck(info, k);
            });
            return {
                numberValidation: numberValidation,
                emptyFields: emptyFields,
                monthValidation: validator.expirationMonth(info.expMonth + ""),
                yearValidation: validator.expirationYear(info.expYear + ""),
                cvvValidation: validator.cvv(info.cvv2, numberValidation.card && numberValidation.card.isAmex ? 4 : 3),
                zipValidation: validator.postalCode(info.zipCode),
                userZipValidation: validator.postalCode(shippingAddress.zip)
            };
        }
    }, {
        key: "getNewUser",
        value: function getNewUser() {
            var user = this.props.order.newUser;
            if (!user) {
                user = {
                    addresses: []
                };
            }
            return user;
        }
    }, {
        key: "getAddress",
        value: function getAddress(maybeAddress) {
            if (maybeAddress) {
                return maybeAddress;
            }
            return {
                country: "USA"
            };
        }
    }, {
        key: "getPaymentInfo",
        value: function getPaymentInfo() {
            var info = this.props.order.paymentInfo;
            if (!info) {
                info = {};
            }
            return info;
        }
    }, {
        key: "updateUser",
        value: function updateUser(fn) {
            var user = this.getNewUser();
            fn(user);
            var order = this.props.order;
            order.newUser = user;
            this.props.updateOrderStore(order);
        }
    }, {
        key: "updateShippingAddress",
        value: function updateShippingAddress(fn) {
            var order = this.props.order;
            var address = this.getAddress(order.shippingAddress);
            fn(address);
            order.shippingAddress = address;
            this.props.updateOrderStore(order);
        }
    }, {
        key: "updateBillingAddress",
        value: function updateBillingAddress(fn) {
            var order = this.props.order;
            var address = this.getAddress(order.billingAddress);
            fn(address);
            order.billingAddress = address;
            this.props.updateOrderStore(order);
        }
    }, {
        key: "updateOrder",
        value: function updateOrder(order) {
            this.props.updateOrderStore(order);
        }
    }, {
        key: "updatePaymentInfo",
        value: function updatePaymentInfo(fn) {
            var info = this.getPaymentInfo();
            fn(info);
            var order = this.props.order;
            order.paymentInfo = info;
            this.props.updateOrderStore(order);
        }
    }], [{
        key: "validatorToState",
        value: function validatorToState(value, v) {
            if (!value) {
                return null;
            }
            if (v.isValid) {
                return "success";
            }
            if (v.isPotentiallyValid) {
                return null;
            }
            return "error";
        }
    }, {
        key: "isNotEmpty",
        value: function isNotEmpty(value) {
            if (value && lodash_1.size(value + "") > 0) {
                return "success";
            }
            return null;
        }
    }, {
        key: "ccImageForValidatorType",
        value: function ccImageForValidatorType(t) {
            switch (t) {
                case "visa":
                    return enums_1.ccImages.visa;
                case "master-card":
                    return enums_1.ccImages.mastercard;
                case "american-express":
                    return enums_1.ccImages.amex;
                case "discover":
                    return enums_1.ccImages.discover;
                default:
                    return null;
            }
        }
    }]);

    return Checkout;
}(React.Component);

var connected = react_redux_1.connect(function (state) {
    return {
        order: state.hotels.order,
        validationErrorMessage: state.hotels.validationError,
        errorMessage: state.hotels.errorMessage,
        loading: state.hotels.orderLoading || state.hotels.loading || state.hotels.searchLoading,
        newDiscountCode: state.hotels.newDiscountCode,
        discountCodeMessage: state.hotels.discountCodeMessage,
        discountCodeLoading: state.hotels.discountCodeLoading,
        newDiscountSuccess: state.hotels.newDiscountSuccess
    };
}, {
    updateOrderStore: hotels_1.updateOrderStore,
    validateCompletedOrder: hotels_1.validateCompletedOrder,
    validationError: hotels_1.validationError,
    checkDiscountCode: hotels_1.checkDiscountCode,
    updateDiscountCode: hotels_1.updateDiscountCode,
    removeDiscountCode: hotels_1.removeDiscountCode
})(Checkout);
exports.default = react_router_dom_1.withRouter(connected);

/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(36);
var react_router_dom_1 = __webpack_require__(49);
var react_bootstrap_1 = __webpack_require__(26);
__webpack_require__(62);
__webpack_require__(71);
__webpack_require__(98);
var hotels_1 = __webpack_require__(37);
__webpack_require__(85);

var Confirm = function (_React$Component) {
    _inherits(Confirm, _React$Component);

    function Confirm() {
        _classCallCheck(this, Confirm);

        return _possibleConstructorReturn(this, (Confirm.__proto__ || Object.getPrototypeOf(Confirm)).apply(this, arguments));
    }

    _createClass(Confirm, [{
        key: "render",
        value: function render() {
            return React.createElement("div", { className: "hotel-listing-c" }, React.createElement("div", { className: "package-container" }, React.createElement("div", { className: "checkout" }, this.renderCart())));
        }
    }, {
        key: "renderCart",
        value: function renderCart() {
            if (!this.props.order || !this.props.order.user) {
                this.props.history.push("/");
                return null;
            }
            var order = this.props.order;
            return React.createElement(react_bootstrap_1.Panel, { bsStyle: "primary", className: "cart" }, React.createElement(react_bootstrap_1.Panel.Heading, null, "Your Order Has Been Received"), React.createElement(react_bootstrap_1.Panel.Body, null, React.createElement("p", null, "Your order number is ", React.createElement("strong", null, order.orderNumber), "."), React.createElement("p", null, "We sent a confirmation email to ", React.createElement("strong", null, order.user.email), "."), React.createElement("p", null, "Thank you!")));
        }
    }]);

    return Confirm;
}(React.Component);

var connected = react_redux_1.connect(function (state) {
    return {
        order: state.hotels.order
    };
}, {
    placeOrder: hotels_1.placeOrder
})(Confirm);
exports.default = react_router_dom_1.withRouter(connected);

/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_bootstrap_1 = __webpack_require__(26);
__webpack_require__(825);
// tslint:disable-next-line
// const headerHtml = require("../html/parksavers_header.html");
exports.Header = function (props) {
    return React.createElement(react_bootstrap_1.Row, { style: { marginTop: "35px" } }, React.createElement(react_bootstrap_1.Col, { xs: 0, lg: 1 }), React.createElement(react_bootstrap_1.Col, { xs: 12, lg: 10 }, React.createElement("div", null)), React.createElement(react_bootstrap_1.Col, { xs: 0, lg: 1 }));
};
// tslint:disable-next-line
// const footerHtml = require("../html/parksavers_footer.html");
exports.Footer = function (props) {
    return React.createElement(react_bootstrap_1.Row, { style: { marginTop: "35px" } }, React.createElement(react_bootstrap_1.Col, { xs: 0, lg: 1 }), React.createElement(react_bootstrap_1.Col, { xs: 12, lg: 10 }, React.createElement("div", null)), React.createElement(react_bootstrap_1.Col, { xs: 0, lg: 1 }));
};

/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = __webpack_require__(36);
exports.Recaptcha = function (props) {
    // const onChange = (value: string) => {
    //     apiPost("/auth/validate", {response: value})
    //         .then(_ => tokenValidated(true));
    // };
    //let captcha: any;
    // setTimeout(() => {
    //     ensureToken().then(token => {
    //         if (!token.validated && captcha) {
    //             captcha.execute();
    //         }
    //     });
    // }, 10000);
    // if (props.recaptchaSiteKey) {
    //     return <ReCAPTCHA ref={(r: any) => captcha = r}
    //                       size="invisible"
    //                       sitekey={props.recaptchaSiteKey}
    //                       onChange={onChange}/>;
    // } else {
    //     return null;
    // }
    return null;
};
var connected = react_redux_1.connect(function (state) {
    return Object.assign({}, state.config);
})(exports.Recaptcha);
exports.default = connected;

/***/ }),

/***/ 572:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(36);
var react_router_dom_1 = __webpack_require__(49);
var react_bootstrap_1 = __webpack_require__(26);
__webpack_require__(62);
__webpack_require__(71);
__webpack_require__(98);
var hotels_1 = __webpack_require__(37);
__webpack_require__(85);
var Cart_1 = __webpack_require__(127);
var PackageTotals_1 = __webpack_require__(170);

var Review = function (_React$Component) {
    _inherits(Review, _React$Component);

    function Review() {
        _classCallCheck(this, Review);

        return _possibleConstructorReturn(this, (Review.__proto__ || Object.getPrototypeOf(Review)).apply(this, arguments));
    }

    _createClass(Review, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps, nextContext) {
            if (nextProps.order && nextProps.order.paymentInfo && !nextProps.order.paymentInfo.ccNum) {
                this.props.history.push("/checkout");
                return;
            }
        }
    }, {
        key: "render",
        value: function render() {
            return React.createElement("div", { className: "hotel-listing-c" }, React.createElement("div", { className: "package-container" }, React.createElement("div", { className: "checkout" }, this.renderCart())));
        }
    }, {
        key: "renderCart",
        value: function renderCart() {
            var _this2 = this;

            if (!this.props.order || !this.props.order.newUser || !this.props.order.paymentInfo) {
                return null;
            }
            var user = this.props.order.newUser;
            var _props$order = this.props.order,
                shippingAddress = _props$order.shippingAddress,
                billingAddress = _props$order.billingAddress,
                billingSameAsShipping = _props$order.billingSameAsShipping;

            var info = this.props.order.paymentInfo;
            return React.createElement(react_bootstrap_1.Panel, { bsStyle: "primary", className: "cart" }, React.createElement(react_bootstrap_1.Panel.Heading, null, "Your Order Summary"), React.createElement(react_bootstrap_1.Panel.Body, null, React.createElement(Cart_1.default, null), React.createElement("h3", null, "Payment Info"), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { xs: 12, lg: 9, className: "payment-info" }, React.createElement(react_bootstrap_1.Col, { xs: 12, lg: 4, className: "line" }, React.createElement("label", null, "Shipping Address"), React.createElement("div", null, React.createElement("div", null, user.firstName, " ", user.lastName), React.createElement("div", null, shippingAddress.address1, " ", shippingAddress.address2), React.createElement("div", null, shippingAddress.city, ", ", shippingAddress.state, " ", shippingAddress.zip), React.createElement("div", null, shippingAddress.country))), billingSameAsShipping ? null : React.createElement(react_bootstrap_1.Col, { xs: 12, lg: 4, className: "line" }, React.createElement("label", null, "Billing Address"), React.createElement("div", null, React.createElement("div", null, billingAddress.address1, " ", billingAddress.address2), React.createElement("div", null, billingAddress.city, ", ", billingAddress.state, " ", billingAddress.zip), React.createElement("div", null, billingAddress.country))), React.createElement(react_bootstrap_1.Col, { xs: 12, lg: 4, className: "line" }, React.createElement("label", null, "Card"), React.createElement("div", null, React.createElement("div", null, this.sanitize(info.ccNum), " (", info.cardType, ")"), React.createElement("div", null, "Expires: ", info.expMonth, "/", info.expYear), React.createElement("div", null, "Billing zip code: ", info.zipCode))))), React.createElement("h3", null, "Totals"), React.createElement(PackageTotals_1.PackageTotals, { order: this.props.order }), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { xs: 12, style: { textAlign: "right" } }, React.createElement(react_bootstrap_1.Button, { bsStyle: "default", style: { marginRight: "15px" }, onClick: function onClick() {
                    return _this2.props.history.push("/checkout");
                } }, "Edit Payment Info"), React.createElement(react_bootstrap_1.Button, { bsStyle: "success", onClick: function onClick() {
                    return _this2.submitOrder();
                } }, "Submit Order")))));
        }
    }, {
        key: "sanitize",
        value: function sanitize(ccNum) {
            var len = ccNum.length;
            if (len < 4) {
                return ccNum;
            }
            var last4 = ccNum.substr(ccNum.length - 4);
            var rest = "*".repeat(len - 4);
            return rest + last4;
        }
    }, {
        key: "submitOrder",
        value: function submitOrder() {
            var _this3 = this;

            this.props.placeOrder(this.props.order).then(function (action) {
                if (action.validationError || _this3.props.errorMessage) {
                    _this3.props.history.push("/checkout");
                } else {
                    _this3.props.history.push("/confirm");
                }
            });
        }
    }]);

    return Review;
}(React.Component);

var connected = react_redux_1.connect(function (state) {
    return {
        order: state.hotels.order,
        errorMessage: state.hotels.errorMessage,
        loading: state.hotels.loading || state.hotels.orderLoading || state.hotels.searchLoading
    };
}, {
    placeOrder: hotels_1.placeOrder
})(Review);
exports.default = react_router_dom_1.withRouter(connected);

/***/ }),

/***/ 573:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(49);
__webpack_require__(62);
__webpack_require__(85);
var Stepper = function Stepper(props) {
    var step = 0;
    if (props.location.pathname.indexOf("summary") > -1) {
        step = 1;
    }
    var steps = [["Choose your tickets", "/tickets"], ["Review your order", "/summary"]];
    return React.createElement("ul", { className: "nav nav-pills nav-stacked stepper" }, steps.map(function (pair, index) {
        var _pair = _slicedToArray(pair, 2),
            txt = _pair[0],
            link = _pair[1];

        var selectedClass = index === step ? "active" : "";
        return React.createElement("li", { className: selectedClass, key: index }, React.createElement(react_router_dom_1.Link, { to: link }, React.createElement("label", null, "Step ", index + 1), " ", txt));
    }));
};
exports.RoutedStepper = react_router_dom_1.withRouter(Stepper);

/***/ }),

/***/ 574:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(36);
var react_router_dom_1 = __webpack_require__(49);
var react_bootstrap_1 = __webpack_require__(26);
var hotels_1 = __webpack_require__(37);
var lodash_1 = __webpack_require__(25);
__webpack_require__(62);
__webpack_require__(71);
__webpack_require__(98);
__webpack_require__(85);
var Stepper_1 = __webpack_require__(573);
var Cart_1 = __webpack_require__(127);
// import {PackageDescription} from "../html/copy";
// import {Address, User} from "../models/user";
var enums_1 = __webpack_require__(171);
var PackageTotals_1 = __webpack_require__(170);

var Summary = function (_React$Component) {
    _inherits(Summary, _React$Component);

    function Summary() {
        _classCallCheck(this, Summary);

        return _possibleConstructorReturn(this, (Summary.__proto__ || Object.getPrototypeOf(Summary)).apply(this, arguments));
    }

    _createClass(Summary, [{
        key: "render",
        value: function render() {
            var smallDevice = window.matchMedia("(max-width: 400px)").matches;
            return React.createElement("div", { className: "hotel-listing-c" }, React.createElement("div", { className: smallDevice ? "" : "package-container" }, React.createElement("div", { className: "left m-b-l" }, React.createElement(Stepper_1.RoutedStepper, null)), React.createElement("div", { className: "right" }, this.renderCart())));
        }
    }, {
        key: "renderCart",
        value: function renderCart() {
            var _this2 = this;

            if (!this.props.order) {
                return null;
            }
            return React.createElement(react_bootstrap_1.Panel, { bsStyle: "primary", className: "cart" }, React.createElement(react_bootstrap_1.Panel.Heading, null, "Your Package"), React.createElement(react_bootstrap_1.Panel.Body, null, React.createElement(Cart_1.default, null), React.createElement("h3", { className: "m-t" }, "Guest Information"), this.renderGuests(), React.createElement("h3", { className: "m-t" }, "Delivery Options"), this.renderDeliverOptions(), React.createElement("h3", { className: "m-t" }, "Trip Interruption Insurance"), this.renderInsurance(), React.createElement("h3", { className: "m-t" }, "Memory Maker"), this.renderMemoryMaker(), React.createElement("h3", { className: "m-t" }, "Totals"), React.createElement(PackageTotals_1.PackageTotals, { order: this.props.order }), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { xs: 12, style: { textAlign: "right" } }, React.createElement(react_bootstrap_1.Button, { bsStyle: "success", onClick: function onClick() {
                    return _this2.goToCheckout();
                } }, "Checkout")))));
        }
    }, {
        key: "renderGuests",
        value: function renderGuests() {
            var _this3 = this;

            var guests = this.props.order.guests || [];
            var numGuests = 1; //this.numGuests();
            guests.length = numGuests;
            lodash_1.range(numGuests).forEach(function (n) {
                var guest = guests[n];
                if (!guest) {
                    guest = { firstName: "", middleName: "", lastName: "", title: "" };
                    guests[n] = guest;
                }
                return guest;
            });
            return React.createElement("div", null, this.props.validationErrorMessage && React.createElement(react_bootstrap_1.Alert, { bsStyle: "danger" }, this.props.validationErrorMessage), guests.map(function (guest, index) {
                return React.createElement(react_bootstrap_1.Row, { key: index }, React.createElement(react_bootstrap_1.Col, { lg: 2, md: 3 }, React.createElement(react_bootstrap_1.FormGroup, null, React.createElement(react_bootstrap_1.ControlLabel, null, "Title *"), React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", value: guest.title, onChange: function onChange(e) {
                        guest.title = e.target.value;
                        _this3.updateGuest(guest, index);
                    } }, React.createElement("option", { value: "", key: "--" }), lodash_1.map(enums_1.titles, function (title) {
                    return React.createElement("option", { value: title.code, key: title.code }, title.name);
                })))), React.createElement(react_bootstrap_1.Col, { lg: 3, md: 6 }, React.createElement(react_bootstrap_1.FormGroup, null, React.createElement(react_bootstrap_1.ControlLabel, null, "First Name *"), React.createElement(react_bootstrap_1.FormControl, { type: "text", value: guest.firstName, onChange: function onChange(e) {
                        guest.firstName = e.target.value;
                        _this3.updateGuest(guest, index);
                    } }))), React.createElement(react_bootstrap_1.Col, { lg: 2, md: 6 }, React.createElement(react_bootstrap_1.FormGroup, null, React.createElement(react_bootstrap_1.ControlLabel, null, "Middle Name"), React.createElement(react_bootstrap_1.FormControl, { type: "text", value: guest.middleName, onChange: function onChange(e) {
                        guest.middleName = e.target.value;
                        _this3.updateGuest(guest, index);
                    } }))), React.createElement(react_bootstrap_1.Col, { lg: 3, md: 6 }, React.createElement(react_bootstrap_1.FormGroup, null, React.createElement(react_bootstrap_1.ControlLabel, null, "Last Name *"), React.createElement(react_bootstrap_1.FormControl, { type: "text", value: guest.lastName, onChange: function onChange(e) {
                        guest.lastName = e.target.value;
                        _this3.updateGuest(guest, index);
                    } }))), React.createElement(react_bootstrap_1.Col, { lg: 2, md: 3 }, React.createElement(react_bootstrap_1.FormGroup, null, React.createElement(react_bootstrap_1.ControlLabel, null, "Suffix"), React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", value: guest.suffix, onChange: function onChange(e) {
                        guest.suffix = e.target.value;
                        _this3.updateGuest(guest, index);
                    } }, React.createElement("option", { value: "", key: "--" }), lodash_1.map(enums_1.suffixes, function (suffix) {
                    return React.createElement("option", { value: suffix.code, key: suffix.code }, suffix.name);
                })))));
            }));
        }
    }, {
        key: "renderDeliverOptions",
        value: function renderDeliverOptions() {
            var _this4 = this;

            var order = this.props.order;
            return React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { md: 12 }, React.createElement(react_bootstrap_1.FormGroup, null, React.createElement(react_bootstrap_1.ControlLabel, null, "Delivery Method"), React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", value: order.shippingMethod || "", onChange: function onChange(e) {
                    order.shippingMethod = e.target.value;
                    _this4.updateOrder(order);
                } }, lodash_1.map(enums_1.deliveryOptions, function (deliveryOption) {
                return React.createElement("option", { value: deliveryOption.code, key: deliveryOption.code }, deliveryOption.name);
            }))), React.createElement("div", null, "Ticket Confirmation codes for Magic Band linking and FastPass+ reservations generally arrive within an hour. Please allow up to 24 hours for codes to arrive.")));
        }
    }, {
        key: "renderInsurance",
        value: function renderInsurance() {
            var _this5 = this;

            var order = this.props.order;
            return React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { md: 12 }, React.createElement(react_bootstrap_1.FormGroup, null, React.createElement(react_bootstrap_1.ControlLabel, null, "Insurance"), React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", value: order.insuranceTickets || 0, onChange: function onChange(e) {
                    order.insuranceTickets = e.target.value;
                    _this5.updateOrder(order);
                } }, React.createElement("option", { value: 0, key: "None" }, "None"), lodash_1.map(enums_1.tripInsurances, function (insuranceOption) {
                return React.createElement("option", { value: insuranceOption.code, key: insuranceOption.code }, insuranceOption.name);
            }))), order.insuranceTickets == 0 ? null : React.createElement("div", null, React.createElement(react_bootstrap_1.FormGroup, null, React.createElement(react_bootstrap_1.Checkbox, { checked: order.insuranceConfirmation, onChange: function onChange(e) {
                    order.insuranceConfirmation = e.target.checked;
                    _this5.updateOrder(order);
                } }, "I have read and understand the Trip Interruption Insurance Terms and Conditions*"), React.createElement(InsuranceTerms, null)))));
        }
    }, {
        key: "renderMemoryMaker",
        value: function renderMemoryMaker() {
            var _this6 = this;

            var order = this.props.order;
            return React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { md: 12 }, React.createElement(react_bootstrap_1.FormGroup, null, React.createElement(react_bootstrap_1.ControlLabel, null, "Purchase Memory Maker today and save $30!Plus receive Free 2 Day Express Shipping on your ticket purchase."), React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", value: order.memoryMaker ? "1" : "0", onChange: function onChange(e) {
                    order.memoryMaker = e.target.value === "1";
                    _this6.updateOrder(order);
                } }, lodash_1.map(enums_1.MemoryMakerOptions, function (memoryOption) {
                return React.createElement("option", { value: memoryOption.code, key: memoryOption.code }, memoryOption.name);
            }))), order.memoryMaker && React.createElement(react_bootstrap_1.FormGroup, null, React.createElement(react_bootstrap_1.Checkbox, { checked: order.memoryMakerConfirmation, onChange: function onChange(e) {
                    order.memoryMakerConfirmation = e.target.checked;
                    _this6.updateOrder(order);
                } }, "I have read and understand the Memory Maker Terms and Conditions*"), React.createElement(MMTerms, null))));
        }
        // private renderGeniePlus(): JSX.Element {
        //     const order = this.props.order;
        //     return (
        //         <Row>
        //             <Col md={12}>
        //                 <FormGroup>
        //                     <ControlLabel>Include Genie+ and get access to Lightning Lane at select attractions at all 4 parks. Genie+ allows you to experience more each day by skipping the standby lines and going through the much faster Lightning Lanes. Price below includes tax!</ControlLabel>
        //                     <FormControl componentClass="select"
        //                                  value={order.geniePlus ? '1' : '0'}
        //                                  onChange={(e: any) => {
        //                                      order.geniePlus = e.target.value === '1';
        //                                      this.updateOrder(order);
        //                                  }}>
        //                         {map(GeniePlusOptions, gp => <option value={gp.code} key={gp.code}>{gp.name}</option>)}
        //                     </FormControl>
        //                 </FormGroup>
        //                 {order.geniePlus && <FormGroup>
        //                     <Checkbox checked={order.geniePlusConfirmation}
        //                               onChange={(e: any) => {
        //                                   order.geniePlusConfirmation = e.target.checked;
        //                                   this.updateOrder(order);
        //                               }}>
        //                         I have read and understand the Genie+ Terms and Conditions*
        //                     </Checkbox>
        //                     <GPTerms/>
        //                 </FormGroup>}
        //             </Col>
        //         </Row>
        //     );
        // }

    }, {
        key: "numGuests",
        value: function numGuests() {
            var tickets = this.props.order.tickets || [];
            var adults = 0,
                children = 0;
            tickets.forEach(function (t) {
                adults = Math.max(adults, t.quantityAdults);
                children = Math.max(children, t.quantityChildren);
            });
            return adults + children;
        }
    }, {
        key: "updateGuest",
        value: function updateGuest(guest, index) {
            var guests = this.props.order.guests || [];
            guests.length = this.numGuests();
            guests[index] = guest;
            this.props.order.guests = guests;
            this.props.updateOrderStore(this.props.order);
        }
    }, {
        key: "updateOrder",
        value: function updateOrder(order) {
            this.props.updateOrder(order);
        }
    }, {
        key: "validateGuests",
        value: function validateGuests() {
            return lodash_1.every(this.props.order.guests, function (guest) {
                return guest.title && guest.firstName && guest.lastName;
            });
        }
    }, {
        key: "goToCheckout",
        value: function goToCheckout() {
            var _this7 = this;

            if (!this.validateGuests()) {
                return this.props.validationError("Please enter all guest information");
            }
            if (this.props.order.insuranceTickets > 0 && !this.props.order.insuranceConfirmation) {
                return this.props.validationError("You must confirm you understand the trip insurance terms and conditions");
            }
            this.props.updateOrder(this.props.order).then(function () {
                _this7.props.history.push("/checkout");
            });
        }
    }]);

    return Summary;
}(React.Component);

var connected = react_redux_1.connect(function (state) {
    return {
        order: state.hotels.order,
        validationErrorMessage: state.hotels.validationError
    };
}, {
    updateOrderStore: hotels_1.updateOrderStore,
    validationError: hotels_1.validationError,
    updateOrder: hotels_1.updateOrder
})(Summary);
exports.default = react_router_dom_1.withRouter(connected);
var InsuranceTerms = function InsuranceTerms() {
    var terms = "Trip Cancellation/Trip Interruption Terms:\nCoverage and benefits include the following, subject to certain exclusions and limitations:\nTrip Cancellation/Trip Interruption (100% of insured Trip Cost), including coverage for nonrefundable prepaid tickets due to covered reasons such as:\nInvoluntary termination or layoff after the effective date of coverage and you have been an active employee with the same employer for at least one year.\nBeing called into active military service, or having military leave revoked, or being reassigned.\nA disabling sickness, injury or death causing trip to be canceled.\nHurricane or inclement weather causing delay or cancellation of travel.\nTerms of Coverage:\nYour purchase is protected when one or more of the covered reasons become applicable to the individual who made the purchase. Proof of reason is required and must be submitted to Park Savers within 7 days of discovery/issue. All claims may be sent to: info@parksavers.com. This includes any termination notices from employer, doctor's note signed and authorized by your physician, death certificate, or military orders for service.\nReimbursement of purchase price will not take place until the purchased items have reached their expiration. During this time guests who may have cancelled their trip due to the above listed reasons are still eligible to use their purchase until expiration. Upon expiration the guest will be paid out in full for the cancelled trip purchase (if not used already) and have submitted the required proof.\nTrip Cancellation/Trip Interruption will not be paid out if any portion of the purchase has been used. \n    ";
    return React.createElement("div", null, React.createElement("h4", null, "Trip Interruption Insurance Terms and Conditions"), React.createElement("textarea", { readOnly: true, style: { width: "100%", height: "175px" }, value: terms }));
};
var MMTerms = function MMTerms() {
    var terms = "Enjoy an unlimited array of photos taken by Disney PhotoPass photographers. including photos taken at select dining experiences and attractions. You can add photos to your account for 30 days (from the date of first download). All media you add within the 30 days can be downloaded (subject to the expiration policy) and shared with family and friends. Does not include photos taken within 3 days of purchase. Purchase is nonrefundable.";
    return React.createElement("div", null, React.createElement("h4", null, "Terms and conditions for Memory Maker"), React.createElement("textarea", { readOnly: true, style: { width: "100%", height: "175px" }, value: terms }));
};
var GPTerms = function GPTerms() {
    var terms = "For the price of $16 per ticket per day at Walt Disney World Resort and $20 per ticket per day at Disneyland Resort, choose the next available time to arrive at a variety of attractions and experiences using the Lightning Lane entrance. You can make one selection at a time, throughout the day \u2013 from classics like Haunted Mansion to thrill rides like Big Thunder Mountain Railroad and newer favorites like Millennium Falcon: Smugglers Run (attractions subject to limited availability). This convenient option is the next evolution of the fan-favorite Disney MaxPass service from Disneyland Resort. Disney Genie+ will also include Disney parks-themed audio experiences and photo features to capture your memories \u2013 augmented reality lenses for those visiting Walt Disney World Resort and unlimited Disney PhotoPass downloads from your day if you are visiting Disneyland Resort.";
    return React.createElement("div", null, React.createElement("h4", null, "Terms and conditions for Genie+"), React.createElement("textarea", { readOnly: true, style: { width: "100%", height: "175px" }, value: terms }));
};

/***/ }),

/***/ 575:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(36);
var react_router_dom_1 = __webpack_require__(49);
var react_bootstrap_1 = __webpack_require__(26);
var lodash_1 = __webpack_require__(25);
var _ = __webpack_require__(25);
__webpack_require__(62);
__webpack_require__(71);
__webpack_require__(98);
var moment = __webpack_require__(1);
var react_dates_1 = __webpack_require__(216);
var hotels_1 = __webpack_require__(37);
var Loading_1 = __webpack_require__(91);
__webpack_require__(85);
var utils_1 = __webpack_require__(38);
var Cart_1 = __webpack_require__(127);
var DL_LOGO = "/img/disneyland.svg";
var DW_LOGO = "/img/disneyworld.svg";
var MIN_FIRST_DATE = moment("2020-07-01T15:08:51-06:00");

var Tickets = function (_React$Component) {
    _inherits(Tickets, _React$Component);

    function Tickets(props) {
        _classCallCheck(this, Tickets);

        var _this = _possibleConstructorReturn(this, (Tickets.__proto__ || Object.getPrototypeOf(Tickets)).call(this, props));

        _this.state = {
            focusedInput: 'startDate'
        };
        return _this;
    }

    _createClass(Tickets, [{
        key: "render",
        value: function render() {
            return React.createElement("div", { className: "hotel-listing-c" }, React.createElement("div", { className: "package-container" }, this.renderTickets()));
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps, prevState, prevContext) {
            if (!this.props.orderTicketInProcess) {
                var orderTicket = this.getDefaultOrderTicket();
                if (orderTicket && this.props.order) {
                    this.props.getTicketPrice(orderTicket);
                    this.props.loadOrderTicketPrice(orderTicket);
                }
            }
        }
    }, {
        key: "getDefaultOrderTicket",
        value: function getDefaultOrderTicket() {
            var ticket = this.defaultTicket();
            if (!ticket) {
                return null;
            }
            return Object.assign({ ticketId: ticket.id, quantityChildren: 1, quantityAdults: 1, firstDate: moment.max(MIN_FIRST_DATE.clone().add(1, 'month'), moment().add(1, 'day')).format("YYYY-MM-DD"), ticketName: ticket.name }, utils_1.ZERO_TOTALS);
        }
    }, {
        key: "getTickets",
        value: function getTickets() {
            var search = this.props.search;
            var destination = search.destination;
            return utils_1.ticketsForDestination(this.props.tickets, destination);
        }
    }, {
        key: "defaultTicket",
        value: function defaultTicket() {
            return this.getTickets().find(function (t) {
                return t.name === "One Park Per Day" && t.days === 3;
            });
        }
    }, {
        key: "getInProcessTicket",
        value: function getInProcessTicket() {
            var orderTicket = this.getOrderTicket();
            return this.getTickets().find(function (t) {
                return t.id === orderTicket.ticketId;
            }) || this.defaultTicket();
        }
    }, {
        key: "updateOrderTicketFor",
        value: function updateOrderTicketFor(days, name) {
            var ticket = this.getInProcessTicket();
            days = days || ticket.days;
            name = name || ticket.name;
            var newTicket = this.getTickets().find(function (t) {
                return t.days === days && t.name === name;
            });
            var orderTicket = this.getOrderTicket();
            orderTicket.ticketId = newTicket.id;
            this.props.loadOrderTicketPrice(orderTicket);
        }
    }, {
        key: "updateOrderTicketQuantities",
        value: function updateOrderTicketQuantities(adult, child) {
            var orderTicket = this.getOrderTicket();
            orderTicket.quantityAdults = adult;
            orderTicket.quantityChildren = child;
            this.props.loadOrderTicketPrice(orderTicket);
        }
    }, {
        key: "getOrderTicket",
        value: function getOrderTicket() {
            if (!this.props.orderTicketInProcess) {
                return this.getDefaultOrderTicket();
            } else {
                return this.props.orderTicketInProcess;
            }
        }
    }, {
        key: "renderDays",
        value: function renderDays() {
            var _this2 = this;

            var search = this.props.search;
            var destination = search.destination;
            var destinationTickets = utils_1.ticketsForDestination(this.props.tickets, destination);
            var ticketDays = _(destinationTickets).map("days").uniq().sortBy().value();
            var ticket = this.getInProcessTicket();
            return React.createElement(react_bootstrap_1.Panel, { bsStyle: "primary" }, React.createElement(react_bootstrap_1.Panel.Heading, null, "Select the Number of Days"), React.createElement(react_bootstrap_1.Panel.Body, { className: "day-select" }, _.map(ticketDays, function (day) {
                return React.createElement("div", { key: day, className: "day", onClick: function onClick() {
                        return _this2.updateOrderTicketFor(day, null);
                    } }, React.createElement("label", null, React.createElement("div", null, day), React.createElement("input", { type: "radio", name: "ticket-days", onChange: function onChange() {
                        return null;
                    }, checked: ticket.days === day })));
            })));
        }
    }, {
        key: "renderTicketNames",
        value: function renderTicketNames() {
            var _this3 = this;

            var search = this.props.search;
            var destination = search.destination;
            var destinationTickets = utils_1.ticketsForDestination(this.props.tickets, destination);
            var ticketTypes = _(destinationTickets).map("name").uniq().sortBy(function (n) {
                return n.indexOf("Hopper") > -1 ? 0 : 1;
            }).value();
            var ticket = this.getInProcessTicket();
            return React.createElement(react_bootstrap_1.Panel, { bsStyle: "primary" }, React.createElement(react_bootstrap_1.Panel.Heading, null, "Select Your Theme Park Tickets"), React.createElement(react_bootstrap_1.Panel.Body, { className: "day-select" }, _.map(ticketTypes, function (ticketType) {
                return React.createElement("div", { key: ticketType, className: "day", onClick: function onClick() {
                        return _this3.updateOrderTicketFor(null, ticketType);
                    } }, React.createElement("label", null, React.createElement("div", null, ticketType), React.createElement("input", { type: "radio", name: "ticket-names", onChange: function onChange() {
                        return null;
                    }, checked: ticket.name === ticketType })));
            })));
        }
    }, {
        key: "renderNumberOfTickets",
        value: function renderNumberOfTickets() {
            var _this4 = this;

            var orderTicket = this.getOrderTicket();
            return React.createElement(react_bootstrap_1.Panel, { bsStyle: "primary" }, React.createElement(react_bootstrap_1.Panel.Heading, null, "Select the Number of Tickets"), React.createElement(react_bootstrap_1.Panel.Body, { className: "day-select" }, React.createElement(PlusMinusPicker, { label: "Ages 10 and up", value: orderTicket.quantityAdults, onChange: function onChange(n) {
                    return _this4.updateOrderTicketQuantities(n, orderTicket.quantityChildren);
                } }), React.createElement(PlusMinusPicker, { label: "Ages 3-9", value: orderTicket.quantityChildren, onChange: function onChange(n) {
                    return _this4.updateOrderTicketQuantities(orderTicket.quantityAdults, n);
                } })));
        }
    }, {
        key: "renderCalendar",
        value: function renderCalendar() {
            var _this5 = this;

            var orderTicket = this.getOrderTicket();
            var ticket = this.getInProcessTicket();
            var lastDate = this.props.orderTicketPriceInfo ? moment(this.props.orderTicketPriceInfo.lastDate).add(1, 'day') : moment().add(45, 'weeks');
            var firstDate = moment.max(moment(), MIN_FIRST_DATE);
            var endOffsetDays = Math.max(ticket.validRange, ticket.days) - 1;
            var smallDevice = window.matchMedia('(max-width: 400px)').matches;
            var startDate = moment.max(moment(orderTicket.firstDate), moment().add(1, 'day'), MIN_FIRST_DATE);
            return React.createElement(react_bootstrap_1.Panel, { bsStyle: "primary" }, React.createElement(react_bootstrap_1.Panel.Heading, null, "Select your First Date in the Park"), React.createElement(react_bootstrap_1.Panel.Body, { className: "calendar-select" }, React.createElement(react_dates_1.DayPickerRangeController, { startDate: startDate, endDate: moment(orderTicket.firstDate).add(endOffsetDays, 'days'), onDatesChange: function onDatesChange(_ref) {
                    var startDate = _ref.startDate,
                        endDate = _ref.endDate;

                    if (startDate && endDate) {
                        orderTicket.firstDate = startDate.format("YYYY-MM-DD");
                        _this5.props.loadOrderTicketPrice(orderTicket);
                    }
                }, focusedInput: this.state.focusedInput, onFocusChange: function onFocusChange(focused) {
                    _this5.setState({ focusedInput: focused || 'startDate' });
                }, withPortal: false, numberOfMonths: smallDevice ? 1 : 2, hideKeyboardShortcutsPanel: true, startDateOffset: function startDateOffset(day) {
                    return day;
                }, isOutsideRange: function isOutsideRange(day) {
                    return firstDate.isAfter(day) || lastDate.isBefore(day);
                }, isDayHighlighted: function isDayHighlighted() {
                    return false;
                }, enableOutsideDays: false, endDateOffset: function endDateOffset(day) {
                    return day.add(endOffsetDays, 'days');
                } }), React.createElement("div", null, "Note: highlighted dates are your ticket valid dates")));
        }
    }, {
        key: "renderSelectionSummary",
        value: function renderSelectionSummary() {
            var _this6 = this;

            var now = moment().valueOf();
            if (this.props.orderTicketLoading && now - this.props.orderTicketLoadingStart > 1500) {
                return React.createElement(Loading_1.LoadingOverlay, null);
            }
            var ticket = this.getInProcessTicket();
            var orderTicket = this.getOrderTicket();
            var priceInfo = this.props.orderTicketPriceInfo;
            if (!ticket || !orderTicket || !priceInfo) {
                return null;
            }
            return React.createElement(react_bootstrap_1.Panel, { bsStyle: "primary" }, React.createElement(react_bootstrap_1.Panel.Heading, null, "Current Selections"), React.createElement(react_bootstrap_1.Panel.Body, null, React.createElement("div", { className: "cart" }, React.createElement("label", null, "Ticket: ", ticket.days, "-Day ", ticket.name), orderTicket.quantityAdults && React.createElement("div", null, React.createElement("span", { className: "ticket-type" }, orderTicket.quantityAdults, " x Ages 10+"), React.createElement("span", { className: "ticket-subtotal" }, "(", utils_1.moneyFormat(priceInfo.adultSubtotal), ")")), orderTicket.quantityChildren && React.createElement("div", null, React.createElement("span", { className: "ticket-type" }, orderTicket.quantityChildren, " x Ages 9-"), React.createElement("span", { className: "ticket-subtotal" }, "(", utils_1.moneyFormat(priceInfo.childSubtotal), ")")), React.createElement("div", { className: "subtotal" }, "Ticket Subtotal: ", utils_1.moneyFormat(orderTicket.subTotal)), React.createElement(react_bootstrap_1.Button, { bsStyle: "success", onClick: function onClick() {
                    return _this6.addTicketToOrder();
                } }, "Add to Order"))));
        }
    }, {
        key: "renderCart",
        value: function renderCart() {
            var _this7 = this;

            if (!this.props.order) {
                return null;
            }
            return React.createElement(react_bootstrap_1.Panel, { bsStyle: "primary", className: "cart" }, React.createElement(react_bootstrap_1.Panel.Heading, null, "Tickets"), React.createElement(react_bootstrap_1.Panel.Body, null, React.createElement(Cart_1.default, null), React.createElement("h3", null, "Order Subtotal"), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { xs: 6, className: "subtotal" }, utils_1.moneyFormat(this.props.order.subTotal)), React.createElement(react_bootstrap_1.Col, { xs: 6, style: { textAlign: "right" } }, React.createElement(react_bootstrap_1.Button, { bsStyle: "success", disabled: lodash_1.size(this.props.order.tickets) === 0, onClick: function onClick() {
                    return _this7.updateAndReview();
                } }, "Review Order")))));
        }
    }, {
        key: "renderTickets",
        value: function renderTickets() {
            var _this8 = this;

            if (this.props.loading || !this.props.order) {
                return React.createElement(Loading_1.LoadingOverlay, null);
            }
            var search = this.props.search;
            var destination = search.destination;
            var destinationLogo = DL_LOGO;
            if (destination.indexOf("Disneyland") === -1) {
                destinationLogo = DW_LOGO;
            }
            return React.createElement("div", { className: "tickets" }, this.props.error && React.createElement(react_bootstrap_1.Alert, { bsStyle: "warning" }, this.props.error), this.props.pauseOrdering ? React.createElement(react_bootstrap_1.Alert, { bsStyle: "info" }, React.createElement("div", null, "Your tickets have been added to your order."), React.createElement("div", null, React.createElement(react_bootstrap_1.Button, { onClick: function onClick() {
                    return _this8.props.setPauseOrdering(false);
                } }, "Add More Tickets"))) : React.createElement("div", null, this.renderDays(), this.renderTicketNames(), this.renderNumberOfTickets(), this.renderCalendar(), this.renderSelectionSummary()), this.renderCart());
        }
    }, {
        key: "addTicketToOrder",
        value: function addTicketToOrder() {
            var orderTicket = this.getOrderTicket();
            var order = this.props.order;
            order.tickets.push(orderTicket);
            order.ticketsSelected = true;
            this.props.setPauseOrdering(false); // if true - show separate block (look setPauseOrdering in client\src\actions\hotels.ts)
            this.props.getTicketPrice(null);
            this.props.updateOrder(order);
        }
    }, {
        key: "updateAndReview",
        value: function updateAndReview() {
            var _this9 = this;

            this.props.updateOrder(this.props.order).then(function () {
                return _this9.props.history.push("/summary");
            });
        }
    }]);

    return Tickets;
}(React.Component);

var PlusMinusPicker = function PlusMinusPicker(_ref2) {
    var label = _ref2.label,
        value = _ref2.value,
        onChange = _ref2.onChange;

    var incrementBy = function incrementBy(by) {
        return function () {
            return onChange(Math.max(value + by, 0));
        };
    };
    return React.createElement("div", { className: "plus-minus-picker" }, React.createElement("label", null, label), React.createElement("div", null, React.createElement("i", { className: "fa fa-minus", onClick: incrementBy(-1) }), React.createElement("span", null, value), React.createElement("i", { className: "fa fa-plus", onClick: incrementBy(1) })));
};
var connected = react_redux_1.connect(function (state) {
    return {
        order: state.hotels.order,
        search: state.hotels.searchCriteria,
        tickets: state.config.tickets,
        loading: state.hotels.loading || state.hotels.orderLoading || state.hotels.searchLoading || state.config.loading,
        orderTicketLoading: state.hotels.orderTicketLoading,
        orderTicketInProcess: state.hotels.orderTicketInProcess,
        error: state.hotels.errorMessage,
        pauseOrdering: state.hotels.pauseOrdering,
        orderTicketLoadingStart: state.hotels.orderTicketLoadingStart,
        orderTicketPriceInfo: state.hotels.orderTicketPriceInfo
    };
}, {
    updateOrder: hotels_1.updateOrder,
    loadOrderTicketPrice: hotels_1.loadOrderTicketPrice,
    setPauseOrdering: hotels_1.setPauseOrdering,
    getTicketPrice: hotels_1.getTicketPrice
})(Tickets);
exports.default = react_router_dom_1.withRouter(connected);

/***/ }),

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ComingSoon = function ComingSoon() {
  return React.createElement("div", null, "Dashboard Coming Soon!");
};
exports.default = ComingSoon;

/***/ }),

/***/ 577:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var order_1 = __webpack_require__(252);
var react_redux_1 = __webpack_require__(36);
var react_bootstrap_1 = __webpack_require__(26);
var react_dates_1 = __webpack_require__(216);
var moment = __webpack_require__(1);
var lodash_1 = __webpack_require__(25);
__webpack_require__(217);
__webpack_require__(62);
var utils_1 = __webpack_require__(38);
var discounts_1 = __webpack_require__(250);
var Loading_1 = __webpack_require__(91);

var DiscountsGrid = function (_React$Component) {
    _inherits(DiscountsGrid, _React$Component);

    function DiscountsGrid() {
        _classCallCheck(this, DiscountsGrid);

        return _possibleConstructorReturn(this, (DiscountsGrid.__proto__ || Object.getPrototypeOf(DiscountsGrid)).apply(this, arguments));
    }

    _createClass(DiscountsGrid, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.updateDiscountList();
        }
    }, {
        key: "updateDiscountList",
        value: function updateDiscountList() {
            this.props.getDiscountList();
        }
    }, {
        key: "save",
        value: function save() {
            var _props = this.props,
                newDiscount = _props.newDiscount,
                saveNewDiscount = _props.saveNewDiscount,
                updateDiscount = _props.updateDiscount;

            if (newDiscount && newDiscount.id) {
                updateDiscount(newDiscount);
            } else {
                saveNewDiscount(newDiscount);
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props2 = this.props,
                discounts = _props2.discounts,
                newDiscount = _props2.newDiscount,
                loading = _props2.loading,
                saveLoading = _props2.saveLoading,
                updateNewDiscount = _props2.updateNewDiscount;

            if (!discounts) {
                discounts = [];
            }
            if (loading) {
                return React.createElement(Loading_1.LoadingOverlay, null);
            }
            return React.createElement("div", null, React.createElement(DiscountEditModal, { close: function close() {
                    return updateNewDiscount(null);
                }, discount: newDiscount, change: this.updateDiscount.bind(this), save: this.save.bind(this), isOpen: !!newDiscount }), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { xs: 12, className: "text-right margin-bottom" }, React.createElement(react_bootstrap_1.Button, { bsStyle: "success", onClick: function onClick() {
                    return updateNewDiscount(order_1.defaultDiscountCode());
                } }, React.createElement("i", { className: "fa fa-plus" }), " Create Discount Code"))), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { xs: 12 }, React.createElement(react_bootstrap_1.Table, { bordered: true, striped: true, hover: true }, React.createElement("thead", null, React.createElement("tr", null, React.createElement("th", null, "Code"), React.createElement("th", null, "Active From"), React.createElement("th", null, "Active To"), React.createElement("th", null, "Fixed Discount in $"), React.createElement("th", null, "% off Order Subtotal"), React.createElement("th", null, "Per Ticket"), React.createElement("th", null, "Active"), React.createElement("th", null, "Created On"), React.createElement("th", null, "Actions"))), React.createElement("tbody", null, discounts.map(function (discount) {
                return React.createElement("tr", { key: discount.id }, React.createElement("td", null, discount.name), React.createElement("td", null, moment(discount.activeFrom).format("LL")), React.createElement("td", null, moment(discount.activeTo).format("LL")), React.createElement("td", { className: "text-right" }, discount.discountFixed !== null && utils_1.moneyFormat(discount.discountFixed)), React.createElement("td", { className: "text-right" }, discount.discountPercent !== null && discount.discountPercent + "%"), React.createElement("td", null, discount.perTicket ? "Applied to Ticket" : "Applied to Order"), React.createElement("td", null, discount.active ? "Active" : "Inactive"), React.createElement("td", null, moment(discount.createdOn).format("LL")), React.createElement("td", { className: "action-buttons" }, React.createElement(react_bootstrap_1.Button, { className: "hint--bottom", onClick: function onClick() {
                        updateNewDiscount(discount);
                    }, "aria-label": "Edit Discount Code" }, React.createElement("i", { className: "fa fa-edit" })), React.createElement(react_bootstrap_1.Button, { className: "hint--bottom", onClick: function onClick() {
                        return _this2.deleteDiscount(discount);
                    }, "aria-label": "Delete Discount Code" }, React.createElement("i", { className: "fa fa-remove red" }))));
            }))))));
        }
    }, {
        key: "updateDiscount",
        value: function updateDiscount(f) {
            var s = lodash_1.clone(this.props.newDiscount);
            f(s);
            this.props.updateNewDiscount(s);
        }
    }, {
        key: "deleteDiscount",
        value: function deleteDiscount(d) {
            if (confirm("Are you sure you want to delete " + d.name + "?")) {
                this.props.deleteDiscount(d);
            }
        }
    }]);

    return DiscountsGrid;
}(React.Component);

var connected = react_redux_1.connect(function (state) {
    return Object.assign({}, state.discounts);
}, {
    getDiscountList: discounts_1.getDiscountList,
    updateNewDiscount: discounts_1.updateNewDiscount,
    saveNewDiscount: discounts_1.saveNewDiscount,
    updateDiscount: discounts_1.updateDiscount,
    deleteDiscount: discounts_1.deleteDiscount
})(DiscountsGrid);
exports.default = connected;

var DiscountEditModal = function (_React$Component2) {
    _inherits(DiscountEditModal, _React$Component2);

    function DiscountEditModal(props, context) {
        _classCallCheck(this, DiscountEditModal);

        var _this3 = _possibleConstructorReturn(this, (DiscountEditModal.__proto__ || Object.getPrototypeOf(DiscountEditModal)).call(this, props, context));

        _this3.state = { focusedInput: null };
        return _this3;
    }

    _createClass(DiscountEditModal, [{
        key: "render",
        value: function render() {
            var _this4 = this;

            var _props3 = this.props,
                isOpen = _props3.isOpen,
                close = _props3.close,
                change = _props3.change,
                discount = _props3.discount,
                save = _props3.save;

            if (!discount) {
                return null;
            }
            var title = discount.id ? "Update" : "Create";
            return React.createElement(react_bootstrap_1.Modal, { show: isOpen, onHide: function onHide() {
                    return close();
                } }, React.createElement(react_bootstrap_1.Modal.Header, null, React.createElement(react_bootstrap_1.Modal.Title, null, title, " Discount Code")), React.createElement(react_bootstrap_1.Modal.Body, null, React.createElement("div", { style: { margin: "10px", clear: "both" } }, React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, null, React.createElement(react_bootstrap_1.FormGroup, null, React.createElement(react_bootstrap_1.ControlLabel, null, "Name*"), React.createElement(react_bootstrap_1.FormControl, { type: "text", value: discount.name, onChange: function onChange(e) {
                    return change(function (u) {
                        return u.name = e.target.value;
                    });
                } })))), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, null, React.createElement(react_bootstrap_1.FormGroup, null, React.createElement(react_bootstrap_1.ControlLabel, null, "Active From - To"), React.createElement("br", null), React.createElement(react_dates_1.DateRangePicker, { showClearDates: true, startDateId: "activeFrom", endDateId: "activeTo", enableOutsideDays: false, isOutsideRange: function isOutsideRange() {
                    return false;
                }, startDate: discount.activeFrom ? moment(discount.activeFrom) : null, endDate: discount.activeTo ? moment(discount.activeTo) : null, onDatesChange: function onDatesChange(evt) {
                    change(function (s) {
                        if (evt.startDate) {
                            s.activeFrom = evt.startDate.toISOString();
                        } else {
                            s.activeFrom = null;
                        }
                        if (evt.endDate) {
                            s.activeTo = evt.endDate.toISOString();
                        } else {
                            s.activeTo = null;
                        }
                    });
                }, focusedInput: this.state.focusedInput, onFocusChange: function onFocusChange(focusedInput) {
                    return _this4.setState({ focusedInput: focusedInput });
                } })))), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, null, React.createElement(react_bootstrap_1.FormGroup, null, React.createElement(react_bootstrap_1.ControlLabel, null, "Fixed Discount in $"), React.createElement(react_bootstrap_1.FormControl, { type: "number", value: discount.discountFixed || "", onChange: function onChange(e) {
                    return change(function (u) {
                        return u.discountFixed = parseFloat(e.target.value);
                    });
                } })))), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, null, React.createElement(react_bootstrap_1.FormGroup, null, React.createElement(react_bootstrap_1.ControlLabel, null, "% off Order Subtotal"), React.createElement(react_bootstrap_1.FormControl, { type: "number", disabled: discount.perTicket, value: discount.discountPercent || "", onChange: function onChange(e) {
                    return change(function (u) {
                        return u.discountPercent = parseFloat(e.target.value);
                    });
                } })))), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, null, React.createElement(react_bootstrap_1.FormGroup, null, React.createElement(react_bootstrap_1.ControlLabel, null, "Per Ticket"), React.createElement(react_bootstrap_1.FormControl, { type: "checkbox", checked: discount.perTicket, onChange: function onChange(e) {
                    return change(function (u) {
                        u.perTicket = e.target.checked;
                        if (u.perTicket) {
                            u.discountPercent = null;
                        }
                    });
                } })))), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, null, React.createElement(react_bootstrap_1.FormGroup, null, React.createElement(react_bootstrap_1.ControlLabel, null, "Is Active"), React.createElement(react_bootstrap_1.FormControl, { type: "checkbox", checked: discount.active, onChange: function onChange(e) {
                    return change(function (u) {
                        return u.active = e.target.checked;
                    });
                } })))))), React.createElement(react_bootstrap_1.Modal.Footer, null, React.createElement(react_bootstrap_1.Button, { bsStyle: "success", onClick: function onClick() {
                    return close();
                } }, "Cancel"), React.createElement(react_bootstrap_1.Button, { bsStyle: "success", onClick: function onClick() {
                    return save(discount);
                } }, "Save Changes")));
        }
    }]);

    return DiscountEditModal;
}(React.Component);

/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(36);
var react_bootstrap_1 = __webpack_require__(26);
var react_bootstrap_2 = __webpack_require__(26);
var security_1 = __webpack_require__(168);
var Loading_1 = __webpack_require__(91);

var Login = function (_React$Component) {
    _inherits(Login, _React$Component);

    function Login(props) {
        _classCallCheck(this, Login);

        var _this = _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this, props, null));

        _this.state = {
            username: "",
            password: ""
        };
        return _this;
    }

    _createClass(Login, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var loading = this.props.loading;

            return React.createElement("div", null, this.props.errorMessage && React.createElement(react_bootstrap_1.Alert, { bsStyle: "danger" }, this.props.errorMessage), React.createElement(react_bootstrap_1.Row, { style: { marginTop: "100px" } }, React.createElement(react_bootstrap_1.Col, { xs: 0, lg: 3 }), React.createElement(react_bootstrap_1.Col, { xs: 12, lg: 6 }, React.createElement(react_bootstrap_1.Panel, null, React.createElement(react_bootstrap_1.Panel.Heading, null, "Parksavers Administrative Login"), React.createElement(react_bootstrap_1.Panel.Body, null, React.createElement("form", { onSubmit: function onSubmit(e) {
                    return _this2.login(e);
                } }, React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { xs: 12 }, React.createElement(react_bootstrap_2.FormGroup, { controlId: "username" }, React.createElement(react_bootstrap_2.ControlLabel, null, "Username"), React.createElement(react_bootstrap_2.FormControl, { type: "text", placeholder: "Username", value: this.state.username, onChange: function onChange(e) {
                    return _this2.setState({ username: e.target.value });
                } })))), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { xs: 12 }, React.createElement(react_bootstrap_2.FormGroup, { controlId: "password" }, React.createElement(react_bootstrap_2.ControlLabel, null, "Password"), React.createElement(react_bootstrap_2.FormControl, { type: "password", placeholder: "Password", value: this.state.password, onChange: function onChange(e) {
                    return _this2.setState({ password: e.target.value });
                } })))), React.createElement(react_bootstrap_1.Row, null, loading && React.createElement(Loading_1.Loading, null), React.createElement(react_bootstrap_1.Col, { xs: 12, style: { textAlign: "right" } }, React.createElement(react_bootstrap_2.Button, { type: "submit", disabled: loading, bsStyle: "primary" }, "Login"))))))), React.createElement(react_bootstrap_1.Col, { xs: 0, lg: 3 })));
        }
    }, {
        key: "login",
        value: function login(evt) {
            evt.preventDefault();
            var _state = this.state,
                username = _state.username,
                password = _state.password;

            if (!(username && password)) {
                return;
            }
            this.props.login(username, password);
        }
    }]);

    return Login;
}(React.Component);

var connected = react_redux_1.connect(function (state) {
    return Object.assign({}, state.security);
}, { login: security_1.login })(Login);
exports.default = connected;

/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(49);
var orders_1 = __webpack_require__(167);
var react_redux_1 = __webpack_require__(36);
var react_bootstrap_1 = __webpack_require__(26);
var react_bootstrap_2 = __webpack_require__(26);
var lodash_1 = __webpack_require__(25);
__webpack_require__(217);
__webpack_require__(62);
var utils_1 = __webpack_require__(38);
var Loading_1 = __webpack_require__(91);
var hotels_1 = __webpack_require__(107);

var OrderDetail = function (_React$Component) {
    _inherits(OrderDetail, _React$Component);

    function OrderDetail(props) {
        _classCallCheck(this, OrderDetail);

        var _this = _possibleConstructorReturn(this, (OrderDetail.__proto__ || Object.getPrototypeOf(OrderDetail)).call(this, props));

        _this.state = { keyDialogOpen: false };
        return _this;
    }

    _createClass(OrderDetail, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var id = this.props.match.params.id;
            this.props.getOrderDetail(id);
        }
    }, {
        key: "componentWillUpdate",
        value: function componentWillUpdate(nextProps, nextState, nextContext) {
            if (nextProps.decryptionKey && this.state.keyPromise) {
                this.state.keyPromise.resolve(nextProps.decryptionKey);
                this.setState({ keyPromise: null });
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var orderDetail = this.props.orderDetail;

            if (this.props.loading) {
                return React.createElement(Loading_1.LoadingOverlay, null);
            }
            if (!orderDetail) {
                return null;
            }
            var haveCC = orderDetail.transactions.find(function (t) {
                return t.haveNotes;
            });
            return React.createElement("div", null, this.props.errorMessage && React.createElement(react_bootstrap_2.Alert, { bsStyle: "danger" }, this.props.errorMessage), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { xs: 6 }, React.createElement(react_router_dom_1.Link, { to: "/admin/orders" }, React.createElement("i", { className: "fa fa-arrow-left" }), " Back to Orders")), React.createElement(react_bootstrap_1.Col, { xs: 6, style: { textAlign: "right" } }, React.createElement(react_bootstrap_2.Button, { style: { marginRight: "15px" }, bsStyle: "primary", onClick: function onClick() {
                    return _this2.props.resendOrderConfirmationEmail(_this2.props.orderDetail.id);
                } }, "Resend Confirmation Email"), React.createElement(react_bootstrap_2.Button, { bsStyle: "primary", onClick: function onClick() {
                    return _this2.setState({ keyDialogOpen: true });
                } }, "Set Encryption Key"))), this.renderOrderStatus(), this.renderCustomerInfo(), React.createElement("h3", null, "Tickets"), this.renderTickets(), React.createElement("h3", null, "Guests"), this.renderGuests(), React.createElement("h3", null, "Transactions", " ", React.createElement(react_bootstrap_2.Button, { disabled: !haveCC, onClick: this.getCardDetails.bind(this) }, "Get Card Details")), this.renderTransactions(), React.createElement(KeyDialog, { decryptionKey: this.props.decryptionKey, setKey: this.props.setKey.bind(this), toggleOpen: function toggleOpen(open) {
                    return _this2.setState({ keyDialogOpen: open });
                }, open: this.state.keyDialogOpen }));
        }
    }, {
        key: "renderGuests",
        value: function renderGuests() {
            var orderDetail = this.props.orderDetail;

            return React.createElement(react_bootstrap_2.Table, { striped: true, condensed: true }, React.createElement("thead", null, React.createElement("tr", null, React.createElement("th", null, "Guest"))), React.createElement("tbody", null, orderDetail.guests.map(function (guest, index) {
                return React.createElement("tr", { key: index }, React.createElement("td", null, guest.title, " ", guest.firstName, " ", guest.middleName, " ", guest.lastName, " ", guest.suffix));
            })));
        }
    }, {
        key: "renderOrderStatus",
        value: function renderOrderStatus() {
            var _this3 = this;

            var orderDetail = this.props.orderDetail;

            var haveCC = orderDetail.transactions.find(function (t) {
                return t.haveNotes;
            });
            return React.createElement(react_bootstrap_1.Row, null, React.createElement("h3", null, "Status"), React.createElement(react_bootstrap_1.Col, { md: 3 }, React.createElement(react_bootstrap_1.FormGroup, null, React.createElement(react_bootstrap_1.ControlLabel, null, "Order Status"), React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", value: orderDetail.orderStatus, onChange: function onChange(e) {
                    return _this3.updateOrder(function (o) {
                        return o.status = e.target.value;
                    });
                } }, React.createElement("option", { value: "pending" }, "Pending"), React.createElement("option", { value: "processing" }, "Processing"), React.createElement("option", { value: "shipped" }, "Shipped"), React.createElement("option", { value: "cancelled" }, "Cancelled")))), React.createElement(react_bootstrap_1.Col, { md: 4 }, React.createElement(react_bootstrap_2.Button, { bsStyle: "primary", disabled: !haveCC, onClick: function onClick() {
                    if (confirm("Are you sure you want to delete the credit card detail? It will be gone forever!")) {
                        _this3.updateOrder(function (o) {
                            return o.clearCardData = true;
                        });
                    }
                } }, "Permanently Delete Credit Card Detail")));
        }
    }, {
        key: "renderCustomerInfo",
        value: function renderCustomerInfo() {
            var _props = this.props,
                _props$orderDetail = _props.orderDetail,
                user = _props$orderDetail.user,
                discounts = _props$orderDetail.discounts,
                orderDetail = _props.orderDetail;

            return React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { md: 6 }, React.createElement("h3", null, "Order Info"), React.createElement(react_bootstrap_2.Table, { striped: true, hover: true }, React.createElement("tbody", null, React.createElement("tr", null, React.createElement("td", null, "First Name"), React.createElement("td", null, user.firstName)), React.createElement("tr", null, React.createElement("td", null, "Last Name"), React.createElement("td", null, user.lastName)), React.createElement("tr", null, React.createElement("td", null, "Phone #"), React.createElement("td", null, user.phoneNumber)), React.createElement("tr", null, React.createElement("td", null, "Email"), React.createElement("td", null, user.email)), React.createElement("tr", null, React.createElement("td", null, "Shipping Method"), React.createElement("td", null, orderDetail.shippingMethod)), React.createElement("tr", null, React.createElement("td", null, "# Tickets Insured"), React.createElement("td", null, orderDetail.insuranceTickets)), React.createElement("tr", null, React.createElement("td", null, "Ticket Total"), React.createElement("td", null, utils_1.moneyFormat(orderDetail.subTotal))), React.createElement("tr", null, React.createElement("td", null, "Shipping Total"), React.createElement("td", null, utils_1.moneyFormat(orderDetail.shippingTotal))), React.createElement("tr", null, React.createElement("td", null, "Insurance Total"), React.createElement("td", null, utils_1.moneyFormat(orderDetail.insuranceTotal))), React.createElement("tr", null, React.createElement("td", null, "Memory Maker"), React.createElement("td", null, utils_1.moneyFormat(orderDetail.memoryMakerTotal))), React.createElement("tr", null, React.createElement("td", null, "Discount"), React.createElement("td", null, utils_1.moneyFormat(orderDetail.discountTotal))), React.createElement("tr", null, React.createElement("td", null, "Grand Total"), React.createElement("td", null, utils_1.moneyFormat(orderDetail.grandTotal)))))), React.createElement(react_bootstrap_1.Col, { md: 6 }, !orderDetail.shippingAddress ? null : React.createElement("div", null, React.createElement("h3", null, "Shipping Address"), React.createElement("div", { className: "address" }, React.createElement("div", null, orderDetail.shippingAddress.address1), React.createElement("div", null, orderDetail.shippingAddress.address2), React.createElement("div", null, orderDetail.shippingAddress.city, " ", orderDetail.shippingAddress.state, ",", " ", orderDetail.shippingAddress.zip))), !orderDetail.billingAddress ? null : React.createElement("div", null, React.createElement("h3", null, "Billing Address"), React.createElement("div", { className: "address" }, React.createElement("div", null, orderDetail.billingAddress.address1), React.createElement("div", null, orderDetail.billingAddress.address2), React.createElement("div", null, orderDetail.billingAddress.city, " ", orderDetail.billingAddress.state, ",", " ", orderDetail.billingAddress.zip))), React.createElement("h3", null, "Discounts"), React.createElement(react_bootstrap_2.ListGroup, null, discounts.map(function (discount) {
                return React.createElement(react_bootstrap_2.ListGroupItem, { key: discount.discountId }, discount.discountName);
            }))));
        }
    }, {
        key: "renderHotels",
        value: function renderHotels() {
            var orderDetail = this.props.orderDetail;

            var hotels = React.createElement(react_bootstrap_2.ListGroup, null, React.createElement(react_bootstrap_2.ListGroupItem, null, "Order has no hotels"));
            if (!lodash_1.isEmpty(orderDetail.hotel)) {
                hotels = React.createElement(react_bootstrap_2.Table, { striped: true, hover: true, className: "cart-hotels" }, React.createElement("thead", null, React.createElement("tr", null, React.createElement("th", null, "Hotel"), React.createElement("th", null, "Dates"), React.createElement("th", null, "Occupants"), React.createElement("th", null))), React.createElement("tbody", null, lodash_1.map(orderDetail.hotel, function (orderHotel, index) {
                    return React.createElement("tr", { key: index }, React.createElement("td", null, React.createElement(react_router_dom_1.Link, { to: "/hotels/" + orderHotel.hotelId, target: "_blank" }, orderHotel.hotelTitle), React.createElement("br", null), orderHotel.roomTitle), React.createElement("td", null, React.createElement("div", null, React.createElement("label", null, "Check-in"), React.createElement("div", null, orderHotel.checkIn)), React.createElement("div", null, React.createElement("label", null, "Check-out"), React.createElement("div", null, orderHotel.checkOut))), React.createElement("td", null, React.createElement("div", null, React.createElement("label", null, "Adults"), React.createElement("div", null, orderHotel.numAdults)), React.createElement("div", null, React.createElement("label", null, "Children"), React.createElement("div", null, lodash_1.size(orderHotel.childAges)))), React.createElement("td", { className: "actions" }, React.createElement(react_bootstrap_2.Button, { className: "hint--bottom", onClick: function onClick() {
                            return orderHotel;
                        }, "aria-label": "Remove Hotel" }, React.createElement("i", { className: "fa fa-remove" }))));
                })));
            }
            return hotels;
        }
    }, {
        key: "renderTickets",
        value: function renderTickets() {
            var _this4 = this;

            var orderDetail = this.props.orderDetail;

            var tickets = React.createElement(react_bootstrap_2.ListGroup, null, React.createElement(react_bootstrap_2.ListGroupItem, null, "Your package has no tickets"));
            if (!lodash_1.isEmpty(orderDetail.tickets)) {
                tickets = React.createElement(react_bootstrap_2.Table, { striped: true, hover: true }, React.createElement("thead", null, React.createElement("tr", null, React.createElement("th", null, "Ticket"), React.createElement("th", null, "# Adults"), React.createElement("th", null, "# Children"), React.createElement("th", null, "First Date"), React.createElement("th", null))), React.createElement("tbody", null, lodash_1.map(orderDetail.tickets, function (orderTicket, index) {
                    var ticket = _this4.props.tickets[orderTicket.ticketId];
                    var ticketLabel = "";
                    if (ticket) {
                        ticketLabel = hotels_1.destinationLabel(ticket.destination) + " " + ticket.days + "-Day " + ticket.name;
                    }
                    return React.createElement("tr", { key: index }, React.createElement("td", null, ticketLabel), React.createElement("td", null, orderTicket.quantityAdults), React.createElement("td", null, orderTicket.quantityChildren), React.createElement("td", null, orderTicket.firstDate), React.createElement("td", { className: "actions" }));
                })));
            }
            return tickets;
        }
    }, {
        key: "renderTransactions",
        value: function renderTransactions() {
            var _this5 = this;

            var orderDetail = this.props.orderDetail;

            var transactionsUI = React.createElement(react_bootstrap_2.ListGroup, null, React.createElement(react_bootstrap_2.ListGroupItem, null, "Your package has no transactions"));
            var transactions = orderDetail.transactions;
            if (this.props.decryptedTransactions) {
                transactions = this.props.decryptedTransactions.map(function (tx) {
                    try {
                        var pmtInfo = JSON.parse(tx.notes);
                        if (pmtInfo) {
                            tx = lodash_1.clone(tx);
                            tx.lastFour = pmtInfo.ccNum;
                            tx.cvv2 = pmtInfo.cvv2;
                        }
                    } catch (e) {
                        _this5.props.setErrorMessage("Failed decrypting transaction " + e);
                    }
                    return tx;
                });
            }
            if (!lodash_1.isEmpty(transactions)) {
                transactionsUI = React.createElement(react_bootstrap_2.Table, { striped: true, hover: true }, React.createElement("thead", null, React.createElement("tr", null, React.createElement("th", null, "Amount"), React.createElement("th", null, "Card Number"), React.createElement("th", null, "Card CVV"), React.createElement("th", null, "Card Exp"), React.createElement("th", null, "Card First Name"), React.createElement("th", null, "Card Last Name"), React.createElement("th", null, "Card Type"), React.createElement("th", null, "Card Zip"))), React.createElement("tbody", null, lodash_1.map(transactions, function (trans, index) {
                    return React.createElement("tr", { key: index }, React.createElement("td", null, utils_1.moneyFormat(trans.amount)), React.createElement("td", null, trans.lastFour), React.createElement("td", null, trans.cvv2 || ""), React.createElement("td", null, trans.cardExpMonth, "/", trans.cardExpYear), React.createElement("td", null, trans.cardFirstName), React.createElement("td", null, trans.cardLastName), React.createElement("td", null, trans.cardType), React.createElement("td", null, trans.cardZip));
                })));
            }
            return transactionsUI;
        }
    }, {
        key: "getCardDetails",
        value: function getCardDetails() {
            var _this6 = this;

            var id = this.props.orderDetail ? this.props.orderDetail.id : this.props.match.params.id;
            this.ensureKey().then(function (key) {
                return _this6.props.getDecryptedTransactions(id, key);
            });
        }
    }, {
        key: "ensureKey",
        value: function ensureKey() {
            if (this.props.decryptionKey) {
                return Promise.resolve(this.props.decryptionKey);
            }
            var future = new utils_1.Future();
            this.setState({ keyPromise: future, keyDialogOpen: true });
            return future.promise;
        }
    }, {
        key: "updateOrder",
        value: function updateOrder(fn) {
            var order = this.props.orderDetail;
            var update = { orderId: order.id };
            fn(update);
            this.props.updateOrder(update);
        }
    }]);

    return OrderDetail;
}(React.Component);

var connected = react_redux_1.connect(function (state) {
    return Object.assign({}, state.orders, { tickets: state.config.tickets });
}, {
    getOrderDetail: orders_1.getOrderDetail,
    setKey: orders_1.setKey,
    getDecryptedTransactions: orders_1.getDecryptedTransactions,
    setErrorMessage: orders_1.setErrorMessage,
    resendOrderConfirmationEmail: orders_1.resendOrderConfirmationEmail,
    updateOrder: orders_1.updateOrder
})(OrderDetail);
exports.default = connected;

var KeyDialog = function (_React$Component2) {
    _inherits(KeyDialog, _React$Component2);

    function KeyDialog(props) {
        _classCallCheck(this, KeyDialog);

        var _this7 = _possibleConstructorReturn(this, (KeyDialog.__proto__ || Object.getPrototypeOf(KeyDialog)).call(this, props));

        _this7.state = { decryptionKey: props.decryptionKey };
        return _this7;
    }

    _createClass(KeyDialog, [{
        key: "render",
        value: function render() {
            var _this8 = this;

            return React.createElement(react_bootstrap_2.Modal, { show: this.props.open, onHide: function onHide() {
                    return _this8.props.toggleOpen(false);
                } }, React.createElement(react_bootstrap_2.Modal.Header, null, React.createElement(react_bootstrap_2.Modal.Title, null, "Encryption Key")), React.createElement(react_bootstrap_2.Modal.Body, null, React.createElement(react_bootstrap_1.FormGroup, null, React.createElement(react_bootstrap_1.ControlLabel, null, "Key"), React.createElement(react_bootstrap_1.FormControl, { componentClass: "textarea", value: this.state.decryptionKey, onChange: function onChange(e) {
                    return _this8.setState({ decryptionKey: e.target.value });
                } }))), React.createElement(react_bootstrap_2.Modal.Footer, null, React.createElement(react_bootstrap_2.Button, { bsStyle: "success", onClick: function onClick() {
                    _this8.props.setKey(_this8.state.decryptionKey);
                    _this8.props.toggleOpen(false);
                } }, "OK")));
        }
    }]);

    return KeyDialog;
}(React.Component);

/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(49);
var orders_1 = __webpack_require__(167);
var react_redux_1 = __webpack_require__(36);
var react_bootstrap_1 = __webpack_require__(26);
var react_dates_1 = __webpack_require__(216);
var moment = __webpack_require__(1);
var lodash_1 = __webpack_require__(25);
__webpack_require__(217);
__webpack_require__(62);
var utils_1 = __webpack_require__(38);

var OrderGrid = function (_React$Component) {
    _inherits(OrderGrid, _React$Component);

    function OrderGrid(props) {
        _classCallCheck(this, OrderGrid);

        var _this = _possibleConstructorReturn(this, (OrderGrid.__proto__ || Object.getPrototypeOf(OrderGrid)).call(this, props));

        _this.state = { focusedInput: null };
        return _this;
    }

    _createClass(OrderGrid, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.doSearch();
        }
    }, {
        key: "doSearch",
        value: function doSearch() {
            this.props.getOrderList(this.props.orderSearchParams);
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var orderSearchParams = this.props.orderSearchParams;

            return React.createElement("div", null, React.createElement(react_bootstrap_1.Row, { className: "top-search" }, React.createElement(react_bootstrap_1.Col, { xs: 6 }, React.createElement(react_bootstrap_1.FormGroup, null, React.createElement(react_bootstrap_1.ControlLabel, null, "Search"), React.createElement(react_bootstrap_1.FormControl, { type: "text", value: orderSearchParams.search, onChange: function onChange(e) {
                    return _this2.updateSearch(function (s) {
                        return s.search = e.target.value;
                    });
                } }))), React.createElement(react_bootstrap_1.Col, { xs: 4 }, React.createElement(react_bootstrap_1.FormGroup, null, React.createElement(react_bootstrap_1.ControlLabel, null, "Check-in -> Check-out"), React.createElement("div", null, React.createElement(react_dates_1.DateRangePicker, { showClearDates: true, startDateId: "checkin", endDateId: "checkout", enableOutsideDays: false, isOutsideRange: function isOutsideRange() {
                    return false;
                }, startDate: orderSearchParams.minDate ? moment(orderSearchParams.minDate) : null, endDate: orderSearchParams.maxDate ? moment(orderSearchParams.maxDate) : null, onDatesChange: function onDatesChange(evt) {
                    _this2.updateSearch(function (s) {
                        if (evt.startDate) {
                            s.minDate = evt.startDate.format(utils_1.LOCAL_DATE_FMT);
                        } else {
                            s.minDate = null;
                        }
                        if (evt.endDate) {
                            s.maxDate = evt.endDate.format(utils_1.LOCAL_DATE_FMT);
                        } else {
                            s.maxDate = null;
                        }
                    });
                }, focusedInput: this.state.focusedInput, onFocusChange: function onFocusChange(focusedInput) {
                    return _this2.setState({ focusedInput: focusedInput });
                } })))), React.createElement(react_bootstrap_1.Col, { xs: 2 }, React.createElement(react_bootstrap_1.ControlLabel, null, "\xA0"), React.createElement(react_bootstrap_1.Button, { bsStyle: "primary", onClick: function onClick() {
                    return _this2.doSearch();
                } }, "Find Orders"))), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { xs: 12 }, React.createElement(react_bootstrap_1.Table, { bordered: true, striped: true, hover: true }, React.createElement("thead", null, React.createElement("tr", null, React.createElement("th", null, "Order Number"), React.createElement("th", null, "Order Date"), React.createElement("th", null, "Order Status"), React.createElement("th", null, "Customer Email"), React.createElement("th", null, "Customer Phone"), React.createElement("th", null, "Order Total"))), React.createElement("tbody", null, this.props.orderList.map(function (order) {
                return React.createElement("tr", { key: order.id }, React.createElement("td", null, React.createElement(react_router_dom_1.Link, { to: "/admin/orders/" + order.id }, order.orderNumber)), React.createElement("td", null, moment(order.createdOn).format("LLLL")), React.createElement("td", null, order.orderStatus), React.createElement("td", null, order.user && order.user.email), React.createElement("td", null, order.user && order.user.phoneNumber), React.createElement("td", null, utils_1.moneyFormat(order.grandTotal)));
            }))))));
        }
    }, {
        key: "updateSearch",
        value: function updateSearch(f) {
            var s = lodash_1.clone(this.props.orderSearchParams);
            f(s);
            this.props.updateSearchParams(s);
        }
    }]);

    return OrderGrid;
}(React.Component);

var connected = react_redux_1.connect(function (state) {
    return Object.assign({}, state.orders);
}, {
    getOrderList: orders_1.getOrderList,
    updateSearchParams: orders_1.updateSearchParams
})(OrderGrid);
exports.default = connected;

/***/ }),

/***/ 581:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(36);
var react_bootstrap_1 = __webpack_require__(26);
var Loading_1 = __webpack_require__(91);
var tickets_1 = __webpack_require__(251);
var hotels_1 = __webpack_require__(107);
var lodash_1 = __webpack_require__(25);
var moment = __webpack_require__(1);
var utils_1 = __webpack_require__(38);
var enums_1 = __webpack_require__(171);

var TicketAdmin = function (_React$Component) {
    _inherits(TicketAdmin, _React$Component);

    function TicketAdmin() {
        _classCallCheck(this, TicketAdmin);

        return _possibleConstructorReturn(this, (TicketAdmin.__proto__ || Object.getPrototypeOf(TicketAdmin)).apply(this, arguments));
    }

    _createClass(TicketAdmin, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.updateTicketList();
        }
    }, {
        key: "updateTicketList",
        value: function updateTicketList() {
            this.props.getTicketList();
            this.props.getDeltaList();
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                tickets = _props.tickets,
                newTicket = _props.newTicket,
                loading = _props.loading,
                saveLoading = _props.saveLoading,
                updateNewTicket = _props.updateNewTicket,
                showInactive = _props.showInactive;

            if (!tickets) {
                tickets = [];
            }
            if (loading) {
                return React.createElement(Loading_1.LoadingOverlay, null);
            }
            var ticketsToShow = tickets;
            if (!showInactive) {
                ticketsToShow = tickets.filter(function (t) {
                    return t.active;
                });
            }
            return React.createElement("div", null, React.createElement(TicketEditModal, { close: function close() {
                    return updateNewTicket(null);
                }, ticket: newTicket, deltas: this.props.deltas, change: this.updateTicket.bind(this), save: this.save.bind(this), isOpen: !!newTicket }), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { xs: 6 }, React.createElement(react_bootstrap_1.FormGroup, null, React.createElement(react_bootstrap_1.Checkbox, { checked: showInactive, onChange: function onChange(e) {
                    _this2.props.setShowInactive(e.target.checked);
                } }, "Show Inactive Tickets"))), React.createElement(react_bootstrap_1.Col, { xs: 6, className: "text-right margin-bottom" }, React.createElement(react_bootstrap_1.Button, { bsStyle: "success", onClick: function onClick() {
                    return updateNewTicket(hotels_1.defaultTicket());
                } }, React.createElement("i", { className: "fa fa-plus" }), " Add new Ticket Type"))), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { xs: 12 }, React.createElement(react_bootstrap_1.Table, { bordered: true, striped: true, hover: true }, React.createElement("thead", null, React.createElement("tr", null, React.createElement("th", null, "Ticket Type"), React.createElement("th", null, "Destination"), React.createElement("th", null, "Days"), React.createElement("th", null, "Standard Adult Price"), React.createElement("th", null, "Standard Child Price"), React.createElement("th", null, "Valid Range"), React.createElement("th", null, "Active"), React.createElement("th", null, "Created On"), React.createElement("th", null, "Actions"))), React.createElement("tbody", null, ticketsToShow.map(function (ticket) {
                return React.createElement("tr", { key: ticket.id }, React.createElement("td", null, ticket.name), React.createElement("td", null, ticket.destination), React.createElement("td", null, ticket.days), React.createElement("td", { className: "text-right" }, ticket.adultPrice !== null && utils_1.moneyFormat(ticket.adultPrice)), React.createElement("td", { className: "text-right" }, ticket.childPrice !== null && utils_1.moneyFormat(ticket.childPrice)), React.createElement("td", null, ticket.validRange), React.createElement("td", null, ticket.active ? "Active" : "Inactive"), React.createElement("td", null, moment(ticket.createdOn).format("LL")), React.createElement("td", { className: "action-buttons" }, React.createElement(react_bootstrap_1.Button, { className: "hint--bottom", onClick: function onClick() {
                        updateNewTicket(ticket);
                    }, "aria-label": "Edit Ticket" }, React.createElement("i", { className: "fa fa-edit" })), React.createElement(react_bootstrap_1.Button, { className: "hint--bottom", onClick: function onClick() {
                        return _this2.deactivateTicket(ticket);
                    }, "aria-label": "Deactivate Ticket" }, React.createElement("i", { className: "fa fa-remove red" }))));
            }))))));
        }
    }, {
        key: "save",
        value: function save(ticket, deltas) {
            var _props2 = this.props,
                newTicket = _props2.newTicket,
                saveNewTicket = _props2.saveNewTicket,
                updateTicket = _props2.updateTicket;

            if (newTicket && newTicket.id) {
                updateTicket(newTicket);
                if (deltas && deltas.length > 0) {
                    this.saveDeltas(ticket, deltas);
                }
            } else {
                saveNewTicket(newTicket);
            }
        }
    }, {
        key: "saveDeltas",
        value: function saveDeltas(ticket, newDeltas) {
            var _this3 = this;

            var ticketDeltasById = lodash_1.groupBy(this.props.deltas.filter(function (d) {
                return d.ticketId === ticket.id;
            }), "id");
            var ticketDeltaIds = lodash_1.compact(lodash_1.keys(ticketDeltasById));
            var newDeltasById = lodash_1.groupBy(newDeltas, "id");
            var newDeltaIds = lodash_1.compact(lodash_1.keys(newDeltasById));
            var idsToDelete = lodash_1.difference(ticketDeltaIds, newDeltaIds);
            var idsToUpdate = lodash_1.intersection(ticketDeltaIds, newDeltaIds);
            var toCreate = newDeltasById["undefined"] || [];
            var toUpdate = idsToUpdate.map(function (id) {
                return lodash_1.head(newDeltasById[id]);
            });
            var toDelete = idsToDelete.map(function (id) {
                return lodash_1.head(ticketDeltasById[id]);
            });
            toCreate.forEach(function (t) {
                return _this3.props.saveNewDelta(t);
            });
            toUpdate.forEach(function (t) {
                return _this3.props.updateDelta(t);
            });
            toDelete.forEach(function (t) {
                return _this3.props.deleteDelta(t);
            });
        }
    }, {
        key: "updateTicket",
        value: function updateTicket(f) {
            var s = lodash_1.clone(this.props.newTicket);
            f(s);
            this.props.updateNewTicket(s);
        }
    }, {
        key: "deactivateTicket",
        value: function deactivateTicket(d) {
            if (confirm("Are you sure you want to deactivate " + d.name + "?")) {
                d.active = false;
                this.props.updateTicket(lodash_1.clone(d));
            }
        }
    }]);

    return TicketAdmin;
}(React.Component);

var connected = react_redux_1.connect(function (state) {
    return Object.assign({}, state.tickets);
}, {
    getTicketList: tickets_1.getTicketList,
    updateNewTicket: tickets_1.updateNewTicket,
    saveNewTicket: tickets_1.saveNewTicket,
    updateTicket: tickets_1.updateTicket,
    deleteTicket: tickets_1.deleteTicket,
    setShowInactive: tickets_1.setShowInactive,
    getDeltaList: tickets_1.getDeltaList,
    updateNewDelta: tickets_1.updateNewDelta,
    saveNewDelta: tickets_1.saveNewDelta,
    updateDelta: tickets_1.updateDelta,
    deleteDelta: tickets_1.deleteDelta
})(TicketAdmin);
exports.default = connected;

var TicketEditModal = function (_React$Component2) {
    _inherits(TicketEditModal, _React$Component2);

    function TicketEditModal(props, context) {
        _classCallCheck(this, TicketEditModal);

        var _this4 = _possibleConstructorReturn(this, (TicketEditModal.__proto__ || Object.getPrototypeOf(TicketEditModal)).call(this, props, context));

        _this4.state = {
            focusedInput: null,
            ticketId: null,
            deltas: []
        };
        return _this4;
    }

    _createClass(TicketEditModal, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps, prevState, prevContext) {
            this.setDeltasFromProps();
        }
    }, {
        key: "setDeltasFromProps",
        value: function setDeltasFromProps() {
            var ticketId = this.props.ticket ? this.props.ticket.id : null;
            if (this.state.ticketId !== ticketId) {
                this.setState({
                    ticketId: ticketId,
                    deltas: this.props.deltas.filter(function (d) {
                        return d.ticketId === ticketId;
                    }).map(lodash_1.clone)
                });
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this5 = this;

            var _props3 = this.props,
                isOpen = _props3.isOpen,
                close = _props3.close,
                change = _props3.change,
                ticket = _props3.ticket,
                save = _props3.save;
            var deltas = this.state.deltas;

            if (!ticket) {
                return null;
            }
            var title = ticket.id ? "Update" : "Create";
            return React.createElement(react_bootstrap_1.Modal, { show: isOpen, onHide: function onHide() {
                    return close();
                } }, React.createElement(react_bootstrap_1.Modal.Header, null, React.createElement(react_bootstrap_1.Modal.Title, null, title, " Ticket")), React.createElement(react_bootstrap_1.Modal.Body, null, React.createElement("div", { style: { margin: "10px", clear: "both" } }, React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, null, React.createElement(react_bootstrap_1.FormGroup, null, React.createElement(react_bootstrap_1.ControlLabel, null, "Ticket Type*"), React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "Ticket Type", value: ticket.name, onChange: function onChange(e) {
                    return change(function (s) {
                        return s.name = e.target.value;
                    });
                } }, enums_1.ticketNames.map(function (d) {
                return React.createElement("option", { value: d.code, key: d.code }, d.name);
            }))))), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, null, React.createElement(react_bootstrap_1.FormGroup, null, React.createElement(react_bootstrap_1.ControlLabel, null, "Destination*"), React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "Destination", value: ticket.destination, onChange: function onChange(e) {
                    return change(function (s) {
                        return s.destination = e.target.value;
                    });
                } }, hotels_1.destinations.map(function (d) {
                return React.createElement("option", { value: d.code, key: d.code }, d.name);
            }))))), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { md: 4 }, React.createElement(react_bootstrap_1.FormGroup, null, React.createElement(react_bootstrap_1.ControlLabel, null, "Days"), React.createElement(react_bootstrap_1.FormControl, { type: "number", min: 3, max: 15, value: ticket.days, onChange: function onChange(e) {
                    return change(function (u) {
                        return u.days = parseInt(e.target.value);
                    });
                } }))), React.createElement(react_bootstrap_1.Col, { md: 4 }, React.createElement(react_bootstrap_1.FormGroup, null, React.createElement(react_bootstrap_1.ControlLabel, null, "Adult Price"), React.createElement(react_bootstrap_1.FormControl, { type: "number", value: ticket.adultPrice || "", onChange: function onChange(e) {
                    return change(function (u) {
                        return u.adultPrice = parseFloat(e.target.value);
                    });
                } }))), React.createElement(react_bootstrap_1.Col, { md: 4 }, React.createElement(react_bootstrap_1.FormGroup, null, React.createElement(react_bootstrap_1.ControlLabel, null, "Child Price"), React.createElement(react_bootstrap_1.FormControl, { type: "number", value: ticket.childPrice || "", onChange: function onChange(e) {
                    return change(function (u) {
                        return u.childPrice = parseFloat(e.target.value);
                    });
                } })))), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, null, React.createElement(react_bootstrap_1.FormGroup, null, React.createElement(react_bootstrap_1.ControlLabel, null, "Valid Range"), React.createElement(react_bootstrap_1.FormControl, { type: "number", value: ticket.validRange || "", onChange: function onChange(e) {
                    return change(function (u) {
                        return u.validRange = parseInt(e.target.value);
                    });
                } })))), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, null, React.createElement(react_bootstrap_1.FormGroup, null, React.createElement(react_bootstrap_1.ControlLabel, null, "Is Active"), React.createElement(react_bootstrap_1.FormControl, { type: "checkbox", checked: ticket.active, onChange: function onChange(e) {
                    return change(function (u) {
                        return u.active = e.target.checked;
                    });
                } })))), !this.state.ticketId ? null : React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, null, React.createElement("h3", null, "Price Adjustments"), React.createElement("div", { className: "adjustment-calc" }, React.createElement("label", null, "Ticket prices are calculated with: "), React.createElement("br", null), "(", React.createElement("span", null, "\"Disney price w/tax\""), " - (", React.createElement("span", null, "\"Disney price wo/tax\""), " * ", React.createElement("span", null, "\"Multiplier\""), ") + ", React.createElement("span", null, "\"Adjustment\""), ") *", React.createElement("span", null, " \"Quantity\"")), React.createElement("div", { className: "text-right" }, React.createElement(react_bootstrap_1.Button, { bsSize: "xsmall", bsClass: "default", onClick: function onClick() {
                    deltas.push({ ticketId: _this5.state.ticketId });
                    _this5.setState({ deltas: deltas });
                } }, "+ Add Adjustment")), React.createElement(react_bootstrap_1.Table, { bordered: true, striped: true, hover: true }, React.createElement("thead", null, React.createElement("tr", null, React.createElement("th", null, "Form"), React.createElement("th", null, "Multiplier"), React.createElement("th", null, "Adult Adjustment"), React.createElement("th", null, "Child Adjustment"), React.createElement("th", null, "Actions"))), React.createElement("tbody", null, deltas.map(function (delta, ix) {
                return React.createElement("tr", { key: delta.id || ix }, React.createElement("td", null, React.createElement(react_bootstrap_1.FormControl, { type: "text", value: delta.form || "", onChange: function onChange(e) {
                        delta.form = e.target.value;
                        _this5.setState({ deltas: deltas });
                    } })), React.createElement("td", null, React.createElement(react_bootstrap_1.FormControl, { type: "number", min: 0, step: "0.01", value: lodash_1.isNil(delta.multiplier) ? "" : delta.multiplier, onChange: function onChange(e) {
                        delta.multiplier = parseFloat(e.target.value);
                        _this5.setState({ deltas: deltas });
                    } })), React.createElement("td", null, React.createElement(react_bootstrap_1.FormControl, { type: "number", min: 0, step: "0.01", value: lodash_1.isNil(delta.adultAdjustment) ? "" : delta.adultAdjustment, onChange: function onChange(e) {
                        delta.adultAdjustment = parseFloat(e.target.value);
                        if (lodash_1.isNaN(delta.adultAdjustment)) {
                            delta.adultAdjustment = e.target.value;
                        }
                        _this5.setState({ deltas: deltas });
                    } })), React.createElement("td", null, React.createElement(react_bootstrap_1.FormControl, { type: "number", min: 0, step: "0.01", value: lodash_1.isNil(delta.childAdjustment) ? "" : delta.childAdjustment, onChange: function onChange(e) {
                        delta.childAdjustment = parseFloat(e.target.value);
                        _this5.setState({ deltas: deltas });
                    } })), React.createElement("td", null, React.createElement(react_bootstrap_1.Button, { className: "hint--bottom", onClick: function onClick() {
                        var ix = deltas.indexOf(delta);
                        deltas.splice(ix, 1);
                        _this5.setState({ deltas: deltas });
                    }, "aria-label": "Delete Adjustment" }, React.createElement("i", { className: "fa fa-remove red" }))));
            }))))))), React.createElement(react_bootstrap_1.Modal.Footer, null, React.createElement(react_bootstrap_1.Button, { bsStyle: "success", onClick: function onClick() {
                    return close();
                } }, "Cancel"), React.createElement(react_bootstrap_1.Button, { bsStyle: "success", onClick: function onClick() {
                    return save(ticket, deltas);
                } }, "Save Changes")));
        }
    }]);

    return TicketEditModal;
}(React.Component);

/***/ }),

/***/ 582:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(49);
var react_redux_1 = __webpack_require__(36);
var react_router_dom_2 = __webpack_require__(49);
var react_bootstrap_1 = __webpack_require__(26);
var Dashboard_1 = __webpack_require__(576);
var OrderGrid_1 = __webpack_require__(580);
var OrderDetail_1 = __webpack_require__(579);
var Discounts_1 = __webpack_require__(577);
var TicketAdmin_1 = __webpack_require__(581);
var token_1 = __webpack_require__(169);
var Login_1 = __webpack_require__(578);
var security_1 = __webpack_require__(168);
var ComingSoon = function ComingSoon() {
    return React.createElement("div", null, "Coming Soon!");
};

var AdminShell = function (_React$Component) {
    _inherits(AdminShell, _React$Component);

    function AdminShell() {
        _classCallCheck(this, AdminShell);

        return _possibleConstructorReturn(this, (AdminShell.__proto__ || Object.getPrototypeOf(AdminShell)).apply(this, arguments));
    }

    _createClass(AdminShell, [{
        key: "componentWillUpdate",
        value: function componentWillUpdate(nextProps, nextState, nextContext) {
            this.checkAutoLogin();
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            this.checkAutoLogin();
        }
    }, {
        key: "checkAutoLogin",
        value: function checkAutoLogin() {
            var _this2 = this;

            token_1.ensureToken().then(function (token) {
                if (token && token.validated && token.userId && !_this2.props.user && !_this2.props.loading && !_this2.props.loadLoggedInFailed) {
                    _this2.props.loadLoggedInUser();
                }
            });
        }
    }, {
        key: "logout",
        value: function logout(event) {
            var _this3 = this;

            event.preventDefault();
            this.props.logout().then(function () {
                return _this3.props.history.push("/admin");
            });
        }
    }, {
        key: "render",
        value: function render() {
            var _this4 = this;

            var token = token_1.getToken();
            var loggedIn = this.props.user && token && token.validated;
            if (!loggedIn) {
                return React.createElement(Login_1.default, null);
            }
            var go = function go(path) {
                return function () {
                    return _this4.props.history.push(path);
                };
            };
            var links = [["/admin", "Dashboard"], ["/admin/orders", "Orders"], ["/admin/tickets", "Tickets"], ["/admin/discounts", "Discounts"]];
            var navItems = links.map(function (link, index) {
                return React.createElement(react_bootstrap_1.NavItem, { key: link[0], eventKey: index, onClick: go(link[0]) }, link[1]);
            });
            var activeKey = links.findIndex(function (link, index) {
                return _this4.props.location.pathname.indexOf(link[0]) > -1 && index > 0;
            });
            var match = this.props.match;

            return React.createElement("div", null, React.createElement(react_bootstrap_1.Navbar, null, React.createElement(react_bootstrap_1.Navbar.Header, null, React.createElement(react_bootstrap_1.Navbar.Brand, null, React.createElement("img", { src: "/wdwtickets/img/logo.png" }))), React.createElement(react_bootstrap_1.Nav, { activeKey: activeKey > -1 ? activeKey : 0 }, navItems), React.createElement(react_bootstrap_1.Navbar.Text, null, React.createElement("a", { href: "#", onClick: this.logout.bind(this) }, "Logout"))), React.createElement(react_router_dom_1.Route, { exact: true, path: match.path + "/", component: Dashboard_1.default }), React.createElement(react_router_dom_1.Route, { exact: true, path: match.path + "/orders", component: OrderGrid_1.default }), React.createElement(react_router_dom_1.Route, { exact: true, path: match.path + "/orders/:id", component: OrderDetail_1.default }), React.createElement(react_router_dom_1.Route, { exact: true, path: match.path + "/tickets", component: TicketAdmin_1.default }), React.createElement(react_router_dom_1.Route, { exact: true, path: match.path + "/discounts", component: Discounts_1.default }));
        }
    }]);

    return AdminShell;
}(React.Component);

var connected = react_redux_1.connect(function (state) {
    return Object.assign({}, state.security);
}, { loadLoggedInUser: security_1.loadLoggedInUser, logout: security_1.logout })(AdminShell);
exports.default = react_router_dom_2.withRouter(connected);

/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(73);
var initialState = function initialState() {
    var cfg = window.psConfig || {};
    return {
        recaptchaSiteKey: cfg.recaptchaSiteKey,
        buildHash: cfg.buildHash,
        tickets: {},
        loading: false
    };
};
function configReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState();
    var action = arguments[1];

    switch (action.type) {
        case common_1.CONFIG_SET:
            return Object.assign({}, state, action.config);
        case common_1.TICKETS_SET:
            return Object.assign({}, state, { tickets: action.tickets, loading: false });
        case common_1.TICKETS_LOADING:
            return Object.assign({}, state, { loading: action.loading });
        default:
            return state;
    }
}
exports.configReducer = configReducer;

/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(25);
var discounts_1 = __webpack_require__(250);
var initialState = function initialState() {
    return {
        loading: false,
        saveLoading: false,
        discounts: []
    };
};
function discountsReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState();
    var action = arguments[1];

    switch (action.type) {
        case discounts_1.DISCOUNTS_LOADING:
            return Object.assign({}, state, { loading: true, errorMessage: null });
        case discounts_1.DISCOUNTS_LOADED:
            return Object.assign({}, state, { loading: false, errorMessage: null, discounts: action.discounts });
        case discounts_1.DISCOUNTS_API_ERROR:
            return Object.assign({}, state, { loading: false, saveLoading: false, errorMessage: action.errorMessage });
        case discounts_1.DISCOUNTS_UPDATE_NEW:
            return Object.assign({}, state, { newDiscount: lodash_1.clone(action.newDiscount) });
        case discounts_1.DISCOUNTS_SAVE_LOADING:
            return Object.assign({}, state, { saveLoading: true });
        case discounts_1.DISCOUNTS_SAVED:
            {
                var discounts = state.discounts;
                discounts.push(action.newDiscount);
                return Object.assign({}, state, { discounts: discounts, newDiscount: null, saveLoading: false });
            }
        case discounts_1.DISCOUNTS_UPDATED:
            {
                var _discounts = state.discounts;
                var ix = lodash_1.findIndex(_discounts, function (d) {
                    return d.id === action.newDiscount.id;
                });
                if (ix > -1) {
                    _discounts.splice(ix, 1, action.newDiscount);
                }
                return Object.assign({}, state, { discounts: _discounts, newDiscount: null, saveLoading: false });
            }
        case discounts_1.DISCOUNTS_DELETED:
            {
                var _discounts2 = state.discounts;
                var _ix = lodash_1.findIndex(_discounts2, function (d) {
                    return d.id === action.newDiscount.id;
                });
                if (_ix > -1) {
                    _discounts2.splice(_ix, 1);
                }
                return Object.assign({}, state, { discounts: _discounts2, newDiscount: null, saveLoading: false });
            }
        default:
            return state;
    }
}
exports.discountsReducer = discountsReducer;

/***/ }),

/***/ 585:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var actions = __webpack_require__(37);
var moment = __webpack_require__(1);
var lodash_1 = __webpack_require__(25);
var hotels_1 = __webpack_require__(107);
var hotels_2 = __webpack_require__(37);
var hotels_3 = __webpack_require__(37);
var hotels_4 = __webpack_require__(37);
var hotels_5 = __webpack_require__(37);
var hotels_6 = __webpack_require__(37);
var utils_1 = __webpack_require__(38);
var initialState = function initialState() {
    var searchCriteria = null;
    var searchJson = utils_1.localStorageGet(hotels_2.HOTEL_UPDATE_SEARCH);
    if (searchJson) {
        searchCriteria = JSON.parse(searchJson);
        searchCriteria.checkIn = moment(searchCriteria.checkIn);
        searchCriteria.checkOut = moment(searchCriteria.checkOut);
    }
    if (!searchCriteria) {
        searchCriteria = {
            destination: hotels_1.destinations[0].code,
            checkIn: moment().add(1, "week"),
            checkOut: moment().add(1, "week").add(3, "days"),
            numAdults: 2,
            childAges: [],
            numRooms: 1,
            includeTickets: true
        };
    }
    return {
        loading: false,
        orderLoading: false,
        searchLoading: false,
        searchCriteria: searchCriteria,
        staleResults: true,
        searchResults: [],
        filteredResults: [],
        editAgesOpen: false,
        newDiscountCode: "",
        discountCodeLoading: false,
        orderTicketLoading: false,
        pauseOrdering: false,
        filters: {
            name: "",
            available: false,
            offer: ""
        }
    };
};
function hotelReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState();
    var action = arguments[1];

    switch (action.type) {
        case actions.HOTEL_SEARCH_LOADING:
            return Object.assign({}, state, { searchLoading: action.loading });
        case actions.HOTEL_LOADING:
            return Object.assign({}, state, { loading: action.loading });
        case actions.HOTEL_SEARCH_RESULTS:
            return Object.assign({}, state, { loading: false, searchCriteriaForResults: lodash_1.cloneDeep(state.searchCriteria), staleResults: false, searchResults: action.searchResults, filteredResults: filterHotels(action.searchResults, state.filters), order: action.order, errorMessage: null });
        case actions.HOTEL_DETAIL:
            return Object.assign({}, state, { loading: false, searchCriteriaForResults: lodash_1.cloneDeep(state.searchCriteria), staleResults: false, order: action.order, hotel: action.hotel, errorMessage: null });
        case actions.HOTEL_UPDATE_SEARCH:
            return Object.assign({}, state, { searchLoading: false, staleResults: !lodash_1.isEqual(action.searchCriteria, state.searchCriteriaForResults), searchCriteria: action.searchCriteria });
        case actions.HOTEL_EDIT_AGES:
            return Object.assign({}, state, { editAgesOpen: action.editAgesOpen && state.searchCriteria.childAges.length > 0 });
        case actions.HOTEL_UPDATE_ORDER:
            return Object.assign({}, state, { order: action.order, orderLoading: false, validationError: null });
        case actions.HOTEL_ORDER_LOADING:
            return Object.assign({}, state, { orderLoading: action.loading });
        case actions.HOTEL_UPDATE_FILTERS:
            return Object.assign({}, state, { filters: action.filters, filteredResults: filterHotels(state.searchResults, action.filters) });
        case hotels_2.HOTEL_API_ERROR:
            return Object.assign({}, state, { loading: false, errorMessage: action.errorMessage });
        case hotels_2.HOTEL_UPDATE_VALIDATION_ERROR:
            return Object.assign({}, state, { loading: false, validationError: action.validationError });
        case hotels_3.HOTEL_UPDATE_DISCOUNT_CODE:
            return Object.assign({}, state, { newDiscountCode: action.newDiscountCode });
        case hotels_2.HOTEL_DISCOUNT_LOADING:
            return Object.assign({}, state, { discountCodeLoading: action.discountCodeLoading });
        case hotels_2.HOTEL_CHECK_DISCOUNT_CODE:
            return Object.assign({}, state, { discountCodeLoading: false, discountCodeMessage: action.discountCodeMessage, newDiscountSuccess: action.newDiscountSuccess, newDiscountCode: action.newDiscountSuccess ? "" : state.newDiscountCode });
        case hotels_2.HOTEL_RESET_ORDER:
            return Object.assign({}, state, { loading: false, validationError: action.validationError, order: {} });
        case hotels_4.HOTEL_GET_TICKET_PRICE_LOADING:
            return Object.assign({}, state, { orderTicketLoading: action.orderTicketLoading, orderTicketLoadingStart: moment().valueOf() });
        case hotels_2.HOTEL_GET_TICKET_PRICE:
            return Object.assign({}, state, { orderTicketLoading: false, errorMessage: null, orderTicketInProcess: action.orderTicket });
        case hotels_5.HOTEL_PAUSE_ORDERING:
            return Object.assign({}, state, { pauseOrdering: action.pauseOrdering });
        case hotels_6.HOTEL_SET_TICKET_PRICE_INFO:
            return Object.assign({}, state, { orderTicketLoading: false, errorMessage: null, orderTicketPriceInfo: action.orderTicketPriceInfo, orderTicketInProcess: action.orderTicketPriceInfo.orderTicket });
        default:
            return state;
    }
}
exports.hotelReducer = hotelReducer;
function filterHotels(hotels, filters) {
    if (!(filters.available || filters.name || filters.offer)) {
        return hotels;
    }
    return hotels.filter(function (h) {
        if (filters.name && h.listing.title.toLowerCase().indexOf(filters.name) === -1) {
            return false;
        }
        if (filters.available && !h.availability) {
            return false;
        }
        return true;
    });
}

/***/ }),

/***/ 586:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = __webpack_require__(229);
var hotels_1 = __webpack_require__(585);
var config_1 = __webpack_require__(583);
var security_1 = __webpack_require__(588);
var orders_1 = __webpack_require__(587);
var discounts_1 = __webpack_require__(584);
var tickets_1 = __webpack_require__(589);
exports.default = redux_1.combineReducers({
    hotels: hotels_1.hotelReducer,
    config: config_1.configReducer,
    security: security_1.securityReducer,
    orders: orders_1.ordersReducer,
    discounts: discounts_1.discountsReducer,
    tickets: tickets_1.ticketsReducer
});

/***/ }),

/***/ 587:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(1);
var orders_1 = __webpack_require__(167);
var utils_1 = __webpack_require__(38);
var LS_KEY_KEY = "__ls_key_key";
var initialState = function initialState() {
    var key = utils_1.localStorageGet(LS_KEY_KEY);
    return {
        loading: false,
        orderList: [],
        orderSearchParams: {
            minDate: moment().add(-1, 'month').format(utils_1.LOCAL_DATE_FMT),
            maxDate: moment().add(1, 'days').format(utils_1.LOCAL_DATE_FMT)
        },
        decryptionKey: key
    };
};
function ordersReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState();
    var action = arguments[1];

    switch (action.type) {
        case orders_1.ORDERS_LOADING:
            return Object.assign({}, state, { loading: true, errorMessage: null });
        case orders_1.ORDERS_LOADED:
            return Object.assign({}, state, { loading: false, errorMessage: null, orderList: action.orderList, decryptedTransactions: null });
        case orders_1.ORDERS_DETAIL_LOADED:
            return Object.assign({}, state, { loading: false, errorMessage: null, orderDetail: action.orderDetail, decryptedTransactions: null });
        case orders_1.ORDERS_API_ERROR:
            return Object.assign({}, state, { loading: false, errorMessage: action.errorMessage });
        case orders_1.ORDERS_UPDATE_SEARCH_PARAMS:
            return Object.assign({}, state, { orderSearchParams: action.orderSearchParams });
        case orders_1.ORDERS_DECRYPTED_TRANS:
            return Object.assign({}, state, { loading: false, decryptedTransactions: action.transactions });
        case orders_1.ORDERS_SET_KEY:
            utils_1.localStorageSet(LS_KEY_KEY, action.key);
            return Object.assign({}, state, { decryptionKey: action.key });
        case orders_1.ORDERS_EMAIL_SENT:
            return Object.assign({}, state, { loading: false, errorMessage: null });
        case orders_1.ORDERS_DETAIL_UPDATE:
            return Object.assign({}, state, { orderDetail: action.orderDetail });
        default:
            return state;
    }
}
exports.ordersReducer = ordersReducer;

/***/ }),

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var security_1 = __webpack_require__(168);
var initialState = function initialState() {
    return {};
};
function securityReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState();
    var action = arguments[1];

    switch (action.type) {
        case security_1.LOGGING_IN:
            return Object.assign({}, state, { loading: true });
        case security_1.LOGIN_COMPLETE:
            return Object.assign({}, state, { user: action.user, loading: false, loadLoggedInFailed: false });
        case security_1.SECURITY_API_ERROR:
            return Object.assign({}, state, { user: null, loading: false, errorMessage: action.errorMessage });
        case security_1.LOAD_LOGGED_IN_FAILED:
            return Object.assign({}, state, { loading: false, user: null, loadLoggedInFailed: true });
        default:
            return state;
    }
}
exports.securityReducer = securityReducer;

/***/ }),

/***/ 589:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(25);
var tickets_1 = __webpack_require__(251);
var initialState = function initialState() {
    return {
        loading: false,
        saveLoading: false,
        showInactive: false,
        tickets: [],
        deltas: []
    };
};
function ticketsReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState();
    var action = arguments[1];

    switch (action.type) {
        case tickets_1.TICKETS_LOADING:
            return Object.assign({}, state, { loading: true, errorMessage: null });
        case tickets_1.TICKETS_LOADED:
            return Object.assign({}, state, { loading: false, errorMessage: null, tickets: action.tickets });
        case tickets_1.TICKETS_API_ERROR:
            return Object.assign({}, state, { loading: false, saveLoading: false, errorMessage: action.errorMessage });
        case tickets_1.TICKETS_UPDATE_NEW:
            return Object.assign({}, state, { newTicket: lodash_1.clone(action.newTicket) });
        case tickets_1.TICKETS_SAVE_LOADING:
            return Object.assign({}, state, { saveLoading: true });
        case tickets_1.TICKETS_SAVED:
            {
                var tickets = state.tickets;
                tickets.push(action.newTicket);
                return Object.assign({}, state, { tickets: tickets, newTicket: null, saveLoading: false });
            }
        case tickets_1.TICKETS_UPDATED:
            {
                var _tickets = state.tickets;
                var ix = lodash_1.findIndex(_tickets, function (d) {
                    return d.id === action.newTicket.id;
                });
                if (ix > -1) {
                    _tickets.splice(ix, 1, action.newTicket);
                }
                return Object.assign({}, state, { tickets: _tickets, newTicket: null, saveLoading: false });
            }
        case tickets_1.TICKETS_DELETED:
            {
                var _tickets2 = state.tickets;
                var _ix = lodash_1.findIndex(_tickets2, function (d) {
                    return d.id === action.newTicket.id;
                });
                if (_ix > -1) {
                    _tickets2.splice(_ix, 1);
                }
                return Object.assign({}, state, { tickets: _tickets2, newTicket: null, saveLoading: false });
            }
        case tickets_1.TICKETS_SHOW_INACTIVE:
            return Object.assign({}, state, { showInactive: action.showInactive });
        case tickets_1.DELTA_LOADED:
            return Object.assign({}, state, { loading: false, errorMessage: null, deltas: action.deltas });
        case tickets_1.DELTA_UPDATE_NEW:
            return Object.assign({}, state, { newDelta: lodash_1.clone(action.newDelta) });
        case tickets_1.DELTA_SAVED:
            {
                var deltas = state.deltas;
                deltas.push(action.newDelta);
                return Object.assign({}, state, { deltas: deltas, newDelta: null, saveLoading: false });
            }
        case tickets_1.DELTA_UPDATED:
            {
                var _deltas = state.deltas;
                var _ix2 = lodash_1.findIndex(_deltas, function (d) {
                    return d.id === action.newDelta.id;
                });
                if (_ix2 > -1) {
                    _deltas.splice(_ix2, 1, action.newDelta);
                }
                return Object.assign({}, state, { deltas: _deltas, newDelta: null, saveLoading: false });
            }
        case tickets_1.DELTA_DELETED:
            {
                var _deltas2 = state.deltas;
                var _ix3 = lodash_1.findIndex(_deltas2, function (d) {
                    return d.id === action.newDelta.id;
                });
                if (_ix3 > -1) {
                    _deltas2.splice(_ix3, 1);
                }
                return Object.assign({}, state, { deltas: _deltas2, newDelta: null, saveLoading: false });
            }
        default:
            return state;
    }
}
exports.ticketsReducer = ticketsReducer;

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var token_1 = __webpack_require__(169);
var api_1 = __webpack_require__(249);
exports.CONFIG_SET = "CONFIG_SET";
exports.TICKETS_SET = "TICKETS_SET";
exports.TICKETS_LOADING = "TICKETS_LOADING";
function apiError(type, err) {
    var msg = err ? err.message ? err.message : err : "Unknown error";
    return {
        type: type,
        errorMessage: msg
    };
}
exports.apiError = apiError;
/**
 * Make an API request - automatically includes the Token authorization header
 * @param {string} url - API url without the version (/auth/token not /api/v1/auth/token)
 * @param {RequestInit} options - fetch options
 * @returns {Promise<T>}
 */
function apiRequest(url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!options) {
        options = {};
    }
    if (!options.headers) {
        options.headers = {};
    }
    return token_1.ensureToken().then(function (token) {
        options.headers.Token = token.token;
        return fetch(api_1.apiBase() + url, options);
    }).then(function (response) {
        return response.text().then(function (txt) {
            try {
                return JSON.parse(txt);
            } catch (ex) {
                return Promise.reject(new Error("API error: " + txt));
            }
        });
    });
}
exports.apiRequest = apiRequest;
/**
 * Send a POST API call to url with body - forwards to apiRequest
 * @param {string} url
 * @param body
 * @returns {Promise<T>}
 */
function apiPost(url, body) {
    return apiRequest(url, {
        body: JSON.stringify(body),
        headers: { "Content-Type": "application/json" },
        method: "post"
    });
}
exports.apiPost = apiPost;
/**
 * Send a POST API call to url with body - forwards to apiRequest
 * @param {string} url
 * @param body
 * @param contentType
 * @returns {Promise<T>}
 */
function apiPut(url, body) {
    var contentType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "application/json";

    return apiRequest(url, {
        body: contentType === "application/json" ? JSON.stringify(body) : body,
        headers: { "Content-Type": contentType },
        method: "put"
    });
}
exports.apiPut = apiPut;
/**
 * Send a DELETE API call to url
 * @param {string} url
 * @param body
 * @param contentType
 * @returns {Promise<T>}
 */
function apiDelete(url, body) {
    var contentType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "application/json";

    var options = {
        method: "delete"
    };
    if (body) {
        options.body = contentType === "application/json" ? JSON.stringify(body) : body;
    }
    if (contentType) {
        options.headers = { "Content-Type": contentType };
    }
    return apiRequest(url, options);
}
exports.apiDelete = apiDelete;
function loadConfig() {
    return function (dispatch) {
        dispatch({ type: exports.TICKETS_LOADING, loading: true });
        return apiRequest("/config").then(function (config) {
            return dispatch({
                type: exports.CONFIG_SET,
                config: config
            });
        });
    };
}
exports.loadConfig = loadConfig;
function loadTickets() {
    return function (dispatch) {
        dispatch({ type: exports.TICKETS_LOADING, loading: true });
        return apiRequest("/tickets").then(function (tickets) {
            return dispatch({
                type: exports.TICKETS_SET,
                tickets: tickets
            });
        });
    };
}
exports.loadTickets = loadTickets;

/***/ }),

/***/ 825:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 826:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 85:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
__webpack_require__(826);
exports.Loading = function (props) {
    return React.createElement("div", { className: "centered-container" }, React.createElement("div", { className: "loading-spinner" }, React.createElement("svg", { className: "spinner", width: "65px", height: "65px", viewBox: "0 0 66 66", xmlns: "http://www.w3.org/2000/svg" }, React.createElement("circle", { className: "path", fill: "none", strokeWidth: "6", strokeLinecap: "round", cx: "33", cy: "33", r: "30" })), React.createElement("label", null, props.label)));
};
exports.Loading.defaultProps = {
    label: "Loading"
};
exports.LoadingOverlay = function (props) {
    return React.createElement("div", { style: props.style, className: "loading-overlay" }, React.createElement(exports.Loading, Object.assign({}, props)));
};
exports.LoadingOverlay.defaultProps = exports.Loading.defaultProps;

/***/ })

},[1070]);


// WEBPACK FOOTER //
// app.js